webpackJsonp(["tnew-event-listing"],{

/***/ "./V7/AsyncLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFlexTicketSelector = exports.loadDatePicker = exports.loadIssueCollector = exports.loadModal = undefined;

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var loadModal = exports.loadModal = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var module;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_require__.e/* import() */("tnew-modal").then(__webpack_require__.bind(null, "./V7/tnew/ui/Modal/index.js"));

          case 2:
            module = _context.sent;
            return _context.abrupt('return', module.default);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function loadModal() {
    return _ref.apply(this, arguments);
  };
}();

var loadIssueCollector = exports.loadIssueCollector = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var module;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __webpack_require__.e/* import() */("tnew-issue-collector").then(__webpack_require__.bind(null, "./V7/tnew/issue-collector.js"));

          case 2:
            module = _context2.sent;
            return _context2.abrupt('return', module.default);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function loadIssueCollector() {
    return _ref2.apply(this, arguments);
  };
}();

var loadDatePicker = exports.loadDatePicker = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    var module;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __webpack_require__.e/* import() */("tnew-date-picker").then(__webpack_require__.bind(null, "./V7/events/listing/ui/DatePicker.js"));

          case 2:
            module = _context3.sent;
            return _context3.abrupt('return', module.default);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function loadDatePicker() {
    return _ref3.apply(this, arguments);
  };
}();

var loadFlexTicketSelector = exports.loadFlexTicketSelector = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    var module;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.e/* import() */("tnew-flex-ticket-selector").then(__webpack_require__.bind(null, "./V7/packages/flex/selections/ticketSelector/FlexTicketSelector.js"));

          case 2:
            module = _context4.sent;
            return _context4.abrupt('return', module.default);

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function loadFlexTicketSelector() {
    return _ref4.apply(this, arguments);
  };
}();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./V7/events/listing/EventListing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _EventsKeywordFilter = __webpack_require__("./V7/events/listing/EventsKeywordFilter.js");

var _EventsKeywordFilter2 = _interopRequireDefault(_EventsKeywordFilter);

var _EventListingService = __webpack_require__("./V7/events/listing/api/EventListingService.js");

var _EventListingService2 = _interopRequireDefault(_EventListingService);

var _EventsCalendarView = __webpack_require__("./V7/events/listing/calendarView/EventsCalendarView.js");

var _EventsCalendarView2 = _interopRequireDefault(_EventsCalendarView);

var _EventsCalendarViewMode = __webpack_require__("./V7/events/listing/calendarView/EventsCalendarViewMode.js");

var _EventsCalendarViewMode2 = _interopRequireDefault(_EventsCalendarViewMode);

var _EventsListView = __webpack_require__("./V7/events/listing/listView/EventsListView.js");

var _EventsListView2 = _interopRequireDefault(_EventsListView);

var _PrimaryViewToggle = __webpack_require__("./V7/events/listing/PrimaryViewToggle.js");

var _PrimaryViewToggle2 = _interopRequireDefault(_PrimaryViewToggle);

var _EventListingViewMode = __webpack_require__("./V7/events/listing/EventListingViewMode.js");

var _EventListingViewMode2 = _interopRequireDefault(_EventListingViewMode);

var _EventListingDateFormat = __webpack_require__("./V7/events/listing/date/EventListingDateFormat.js");

var _EventListingDateFormat2 = _interopRequireDefault(_EventListingDateFormat);

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

var _UrlSearchParamsConfig = __webpack_require__("./V7/events/listing/UrlSearchParamsConfig.js");

var _UrlSearchParamsConfig2 = _interopRequireDefault(_UrlSearchParamsConfig);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventListing = function EventListing() {
  var constructorOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var dateFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _classCallCheck3.default)(this, EventListing);

  var defaults = {
    calendarViewMode: _EventsCalendarViewMode2.default.MONTH,
    defaultView: _EventListingViewMode2.default.CALENDAR,
    additionalApiData: {}
  };

  var convertedDates = {
    defaultDisplayDate: (0, _DateHelpers.parseYYYYMMDD)(constructorOptions.defaultDisplayDate),
    earliestEventDate: (0, _DateHelpers.parseYYYYMMDD)(constructorOptions.earliestEventDate),
    latestEventDate: (0, _DateHelpers.parseYYYYMMDD)(constructorOptions.latestEventDate),
    listingStartDate: (0, _DateHelpers.parseYYYYMMDD)(constructorOptions.listingStartDate),
    listingEndDate: (0, _DateHelpers.parseYYYYMMDD)(constructorOptions.listingEndDate)
  };

  // Merge config sources in the following order:
  var config = (0, _assign2.default)(defaults, constructorOptions, convertedDates, _UrlSearchParamsConfig2.default);

  _EventListingDateFormatter2.default.setDateFormats(dateFormats);
  _EventListingService2.default.setAdditionalApiData(config.additionalApiData);

  var isMultiMode = config.isMultiMode,
      defaultView = config.defaultView;


  var keywordFilter = new _EventsKeywordFilter2.default(config);
  var viewToggle = new _PrimaryViewToggle2.default(defaultView, isMultiMode);

  if (isMultiMode || defaultView === _EventListingViewMode2.default.LIST) {
    this.listView = new _EventsListView2.default(config, keywordFilter, viewToggle);
  }
  if (isMultiMode || defaultView === _EventListingViewMode2.default.CALENDAR) {
    this.calendarView = new _EventsCalendarView2.default(config, keywordFilter, viewToggle);
  }

  viewToggle.notify();
};

EventListing.ViewMode = _EventListingViewMode2.default;
EventListing.DateFormat = _EventListingDateFormat2.default;

window.tnew.EventListing = EventListing;

exports.default = EventListing;

/***/ }),

/***/ "./V7/events/listing/EventListingPrimaryView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventsKeywordFilter = __webpack_require__("./V7/events/listing/EventsKeywordFilter.js");

var _EventsKeywordFilter2 = _interopRequireDefault(_EventsKeywordFilter);

var _PrimaryViewToggle = __webpack_require__("./V7/events/listing/PrimaryViewToggle.js");

var _PrimaryViewToggle2 = _interopRequireDefault(_PrimaryViewToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Messaging = window.tnew.ui.messaging;

var EventListingPrimaryView = function () {
  function EventListingPrimaryView(config, keywordFilter, viewToggle) {
    (0, _classCallCheck3.default)(this, EventListingPrimaryView);

    this.keywordFilter = keywordFilter;
    this.config = config;
    this.isVisible = false;

    this.keywordFilter.on(_EventsKeywordFilter2.default.UPDATE, this.onKeywordFilterUpdate.bind(this));

    viewToggle.on(_PrimaryViewToggle2.default.UPDATE, this.onPrimaryViewModeUpdate.bind(this));
  }

  (0, _createClass3.default)(EventListingPrimaryView, [{
    key: 'onPrimaryViewModeUpdate',
    value: function onPrimaryViewModeUpdate(_ref) {
      var mode = _ref.mode;

      this.isVisible = this.constructor.ViewMode === mode;

      if (this.isVisible) {
        this.fetchData();
      }
    }
  }, {
    key: 'onKeywordFilterUpdate',
    value: function onKeywordFilterUpdate() {
      if (this.isVisible) {
        this.fetchData();
      }
    }
  }, {
    key: 'fetchData',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var view, keywords, data;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                view = this.getCurrentView();
                keywords = this.keywordFilter.getSelectedKeywords();
                data = void 0;


                Messaging.clear();

                _context.prev = 4;
                _context.next = 7;
                return this.store.fetchData(view.getRangeForSelectedDate(), keywords);

              case 7:
                data = _context.sent;
                _context.next = 16;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Messaging.clear();
                Messaging.addError('An unexpected error has occured.');
                Messaging.focusUserOnMessages();
                return _context.abrupt('return');

              case 16:

                if (data) {
                  view.setData(data);
                } else {
                  // console.warn('fetch result ignored');
                }

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchData() {
        return _ref2.apply(this, arguments);
      }

      return fetchData;
    }()
  }]);
  return EventListingPrimaryView;
}();

exports.default = EventListingPrimaryView;

/***/ }),

/***/ "./V7/events/listing/EventListingViewClasses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE = 'tn-event-listing-view';

var EventListingViewClasses = {
  BASE: BASE,
  LOADING_MODIFIER: BASE + '--loading',
  CONTROLS_CONTAINER: BASE + '__controls-container',
  RESULTS_CONTAINER: BASE + '__results-container',
  RESULTS_HEADING: BASE + '__results-heading'
};

exports.default = EventListingViewClasses;

/***/ }),

/***/ "./V7/events/listing/EventListingViewMode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CALENDAR: 'calendar',
  LIST: 'list'
};

/***/ }),

/***/ "./V7/events/listing/EventsKeywordFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

var _events = __webpack_require__("./node_modules/events/events.js");

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventsKeywordFilter = function (_EventEmitter) {
  (0, _inherits3.default)(EventsKeywordFilter, _EventEmitter);

  function EventsKeywordFilter(_ref) {
    var forcedKeywords = _ref.forcedKeywords,
        isMultiMode = _ref.isMultiMode;
    (0, _classCallCheck3.default)(this, EventsKeywordFilter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventsKeywordFilter.__proto__ || (0, _getPrototypeOf2.default)(EventsKeywordFilter)).call(this));

    if (forcedKeywords) {
      _this.forcedKeywords = forcedKeywords;
      return (0, _possibleConstructorReturn3.default)(_this);
    }

    _this.$el = (0, _jquery2.default)('#tn-events-keyword-filter');
    _this.$inputs = _this.$el.find('.js-tn-events-keyword-filter-input');
    _this.$btnReset = _this.$el.find('#tn-events-keyword-filter-btn-clear-all-keywords');

    _this.userSelectedValues = [];
    _this.allKeywordValues = _this.$inputs.toArray().map(function (el) {
      return el.value;
    });

    _this.$btnReset.on('click', _this.onBtnReset.bind(_this));
    _this.$inputs.on('change', _this.onInputChange.bind(_this));

    if (isMultiMode) {
      _this.$el.addClass('tn-events-keyword-filter--event-listing-multi-mode');
    }

    _this.$el.show();
    return _this;
  }

  (0, _createClass3.default)(EventsKeywordFilter, [{
    key: 'onBtnReset',
    value: function onBtnReset() {
      this.userSelectedValues = [];

      this.$inputs.prop('checked', false);
      this.$btnReset.attr('disabled', true);
      this.dispatchUpdate();
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(event) {
      var value = event.target.value;
      var index = this.userSelectedValues.indexOf(value);

      if (index === -1) {
        this.userSelectedValues.push(value);
      } else {
        this.userSelectedValues.splice(index, 1);
      }

      this.$btnReset.attr('disabled', this.userSelectedValues.length === 0);
      this.dispatchUpdate();
    }
  }, {
    key: 'dispatchUpdate',
    value: function dispatchUpdate() {
      this.emit(EventsKeywordFilter.UPDATE);
    }
  }, {
    key: 'getSelectedKeywords',
    value: function getSelectedKeywords() {
      if (this.forcedKeywords) {
        return this.forcedKeywords;
      }

      if (this.userSelectedValues.length > 0) {
        return [].concat((0, _toConsumableArray3.default)(this.userSelectedValues));
      }

      return this.allKeywordValues;
    }
  }]);
  return EventsKeywordFilter;
}(_events2.default);

EventsKeywordFilter.UPDATE = 'tnEventsKeywordFilter:update';

exports.default = EventsKeywordFilter;

/***/ }),

/***/ "./V7/events/listing/Loaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadDatePicker = undefined;

var _AsyncLoader = __webpack_require__("./V7/AsyncLoader.js");

exports.loadDatePicker = _AsyncLoader.loadDatePicker;

/***/ }),

/***/ "./V7/events/listing/PrimaryViewToggle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__("./node_modules/events/events.js");

var _events2 = _interopRequireDefault(_events);

var _TabNav = __webpack_require__("./V7/events/listing/ui/TabNav.js");

var _TabNav2 = _interopRequireDefault(_TabNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrimaryViewToggle = function (_EventEmitter) {
  (0, _inherits3.default)(PrimaryViewToggle, _EventEmitter);

  function PrimaryViewToggle(mode) {
    var isMultiMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, _classCallCheck3.default)(this, PrimaryViewToggle);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PrimaryViewToggle.__proto__ || (0, _getPrototypeOf2.default)(PrimaryViewToggle)).call(this));

    _this.mode = mode;

    _this.tabNav = new _TabNav2.default('#tn-event-listing-mode-tab-nav', {
      mode: _this.mode,
      onChange: _this.onTabChange.bind(_this)
    });

    if (isMultiMode) {
      _this.tabNav.$nav.show();
    }
    return _this;
  }

  (0, _createClass3.default)(PrimaryViewToggle, [{
    key: 'onTabChange',
    value: function onTabChange(mode) {
      if (mode !== this.mode) {
        this.mode = mode;
        this.notify(mode);
      }
    }
  }, {
    key: 'notify',
    value: function notify() {
      this.emit(PrimaryViewToggle.UPDATE, { mode: this.mode });
    }
  }]);
  return PrimaryViewToggle;
}(_events2.default);

PrimaryViewToggle.UPDATE = 'tnPrimaryViewToggle:update';

exports.default = PrimaryViewToggle;

/***/ }),

/***/ "./V7/events/listing/UrlSearchParamsConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventListingViewMode = __webpack_require__("./V7/events/listing/EventListingViewMode.js");

var _EventListingViewMode2 = _interopRequireDefault(_EventListingViewMode);

var _EventsCalendarViewMode = __webpack_require__("./V7/events/listing/calendarView/EventsCalendarViewMode.js");

var _EventsCalendarViewMode2 = _interopRequireDefault(_EventsCalendarViewMode);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Use URLSearchParams if browser supports it, otherwise regex:
var params = 'URLSearchParams' in window ? new URLSearchParams(document.location.search.toLowerCase()) : {
  get: function get(name_) {
    var name = name_.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i');
    var results = regex.exec(location.search);
    return !results ? results : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};

var search = {
  // loads specific keywords only (Note: Use of this parameter
  // will hide the keyword filters from the listing and calendar pages.)
  k: params.get('k'),

  // loads the page to display items beginning with the start date
  // (Note: Use of this parameter will hide the date range filter from the listing page.)
  startDate: params.get('startdate'),
  endDate: params.get('enddate'),

  hideDate: params.get('hidedate'),

  // loads the page in *either* the list view or the calendar view
  view: params.get('view'),

  // loads the calendar grid in a specific format; day, week, or month
  span: params.get('span')
};

var startDate = (0, _DateHelpers.parseYYYYMMDD)(search.startDate);
var endDate = (0, _DateHelpers.parseYYYYMMDD)(search.endDate);
var hideListViewControls = search.hideDate !== null || !!startDate || !!endDate;
var hideListViewResultsHeading = search.hideDate !== null;
var forcedKeywords = null;
var defaultView = null;
var calendarViewMode = null;

if (search.k) {
  forcedKeywords = search.k.split(',');
}

if (search.view === _EventListingViewMode2.default.CALENDAR || search.view === _EventListingViewMode2.default.LIST) {
  defaultView = search.view;
}

if (search.span === _EventsCalendarViewMode2.default.DAY || search.span === _EventsCalendarViewMode2.default.WEEK || search.span === _EventsCalendarViewMode2.default.MONTH) {
  calendarViewMode = search.span;
}

// This exported object gets merged/assigned last to main EventListing config
var config = {
  forcedKeywords: forcedKeywords,
  hideListViewControls: hideListViewControls,
  hideListViewResultsHeading: hideListViewResultsHeading
};

if (defaultView) {
  config.defaultView = defaultView;
  config.isMultiMode = false;
} else {
  config.isMultiMode = true;
}

// We only want to override the following properties if they're present:
if (calendarViewMode) {
  config.calendarViewMode = calendarViewMode;
}

if (startDate) {
  config.earliestEventDate = startDate;
  config.defaultDisplayDate = startDate;
}

if (endDate) {
  config.latestEventDate = endDate;
}

exports.default = config;

/***/ }),

/***/ "./V7/events/listing/api/DataStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("./node_modules/babel-runtime/core-js/json/stringify.js");

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__("./node_modules/events/events.js");

var _EventListingService = __webpack_require__("./V7/events/listing/api/EventListingService.js");

var _EventListingService2 = _interopRequireDefault(_EventListingService);

var _productionsFilter = __webpack_require__("./V7/events/listing/api/productionsFilter.js");

var _productionsFilter2 = _interopRequireDefault(_productionsFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataStore = function (_EventEmitter) {
  (0, _inherits3.default)(DataStore, _EventEmitter);

  function DataStore() {
    var dataTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck3.default)(this, DataStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DataStore.__proto__ || (0, _getPrototypeOf2.default)(DataStore)).call(this));

    _this.lastResult = null;
    _this.lastRequestData = null;
    _this.dataTransform = dataTransform;
    return _this;
  }

  (0, _createClass3.default)(DataStore, [{
    key: 'fetchData',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref, keywords) {
        var startDate = _ref.startDate,
            endDate = _ref.endDate;
        var requestData, data;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestData = {
                  startDate: startDate,
                  endDate: endDate,
                  keywords: keywords
                };

                if (!this.isLastResultReusable(requestData)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', this.lastResult);

              case 3:

                this.emit('fetchStart');

                this.lastRequestData = requestData;
                data = null;
                _context.prev = 6;
                _context.next = 9;
                return _EventListingService2.default.post(requestData);

              case 9:
                data = _context.sent;
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                this.lastRequestData = null;
                this.emit('fetchFailed');

                throw _context.t0;

              case 17:
                if (!(requestData === this.lastRequestData)) {
                  _context.next = 23;
                  break;
                }

                data.productions = (0, _productionsFilter2.default)(data.productions);
                if (this.dataTransform !== null) {
                  data = this.dataTransform(data);
                }
                this.lastResult = data;
                this.emit('fetchEnd');
                return _context.abrupt('return', data);

              case 23:
                return _context.abrupt('return', null);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchData(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: 'isLastResultReusable',
    value: function isLastResultReusable(requestData) {
      var last = this.lastRequestData,
          lastResult = this.lastResult;


      if (last === null || lastResult === null) {
        return false;
      }

      if (last.startDate.getTime() <= requestData.startDate.getTime() && last.endDate.getTime() >= requestData.endDate.getTime() && last.keywords.length === requestData.keywords.length &&
      // Note we're only using json as a lazy equality check because
      // we know this array small, simple, and flat
      (0, _stringify2.default)(last.keywords.sort()) === (0, _stringify2.default)(requestData.keywords.sort())) {
        return true;
      }

      return false;
    }
  }]);
  return DataStore;
}(_events.EventEmitter);

exports.default = DataStore;

/***/ }),

/***/ "./V7/events/listing/api/EventListingService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var post = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data_) {
    var service, data, productions;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            service = new Service();
            data = (0, _assign2.default)({}, additionalApiData, data_);


            data.startDate = (0, _DateFormatter.formatISOBasic)(data.startDate);
            data.endDate = (0, _DateFormatter.formatISOBasic)(data.endDate);

            _context.next = 6;
            return service.post(relativeUrl, data);

          case 6:
            productions = _context.sent;
            return _context.abrupt('return', {
              productions: productions,
              requestData: data
            });

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function post(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _DateFormatter = __webpack_require__("./V7/events/listing/date/DateFormatter.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Service = window.tnew.lib.ajax.Service;

var relativeUrl = 'api/products/productionseasons';
var additionalApiData = {};

function setAdditionalApiData(data) {
  additionalApiData = data;
}

exports.default = {
  setAdditionalApiData: setAdditionalApiData,
  post: post
};

/***/ }),

/***/ "./V7/events/listing/api/productionsFilter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function productionsFilter(productions) {
  var filteredProductions = [];

  productions.forEach(function (production) {
    // if (!production.isVisible) {
    //   console.log('skipping non-visible production:', production);
    //   return;
    // }

    var filteredPerformances = production.performances
    // .filter((perf) => {
    //   if (!perf.isPerformanceVisible) {
    //     console.log('removing non visible performance:', perf);
    //     return false;
    //   }

    //   // Weed out performances that don't have a valid displayDate
    //   if (!perf.displayDate && perf.displayDate === 'null') {
    //     console.log('removing invalid displayDate perf:', perf);
    //     return false;
    //   }

    //   return true;
    // })
    .map(function (perf) {
      return (
        // Prep performances with any additional properties
        (0, _assign2.default)({}, perf, {
          iso8601Date: new Date(perf.iso8601DateString)
        })
      );
    });

    if (filteredPerformances.length > 0) {
      filteredProductions.push((0, _assign2.default)({}, production, {
        performances: filteredPerformances
      }));
    }
  });

  return filteredProductions;
}

exports.default = productionsFilter;

/***/ }),

/***/ "./V7/events/listing/calendarView/CalendarDayView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _CalendarModeBaseView2 = __webpack_require__("./V7/events/listing/calendarView/CalendarModeBaseView.js");

var _CalendarModeBaseView3 = _interopRequireDefault(_CalendarModeBaseView2);

var _EventsCalendarViewMode = __webpack_require__("./V7/events/listing/calendarView/EventsCalendarViewMode.js");

var _EventsCalendarViewMode2 = _interopRequireDefault(_EventsCalendarViewMode);

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

var _EventDayList = __webpack_require__("./V7/events/listing/calendarView/html/EventDayList.js");

var _EventDayList2 = _interopRequireDefault(_EventDayList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarDayView = function (_CalendarModeBaseView) {
  (0, _inherits3.default)(CalendarDayView, _CalendarModeBaseView);

  function CalendarDayView(eventEmitter, config) {
    (0, _classCallCheck3.default)(this, CalendarDayView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CalendarDayView.__proto__ || (0, _getPrototypeOf2.default)(CalendarDayView)).call(this, eventEmitter, config, _EventsCalendarViewMode2.default.DAY));

    _this.setResultViews([new _EventDayList2.default()]);
    return _this;
  }

  (0, _createClass3.default)(CalendarDayView, [{
    key: 'initDatepicker',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(DatePicker, _ref) {
        var date = _ref.date,
            minDate = _ref.minDate,
            maxDate = _ref.maxDate;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.datePicker = new DatePicker({
                  date: date,
                  minDate: minDate,
                  maxDate: maxDate,
                  id: 'tn-event-calendar-input-day',
                  label: 'Select Day',
                  dateFormatter: _EventListingDateFormatter2.default.standardDate,
                  hideLabel: true,
                  rangeType: DatePicker.RangeType.DAY,
                  onChange: this.onDateChange.bind(this)
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initDatepicker(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return initDatepicker;
    }()
  }, {
    key: 'getRangeForSelectedDate',
    value: function getRangeForSelectedDate() {
      var date = this.selectedDate;


      return {
        startDate: (0, _DateHelpers.startOfDay)(date),
        endDate: (0, _DateHelpers.endOfDay)(date)
      };
    }
  }]);
  return CalendarDayView;
}(_CalendarModeBaseView3.default);

exports.default = CalendarDayView;

/***/ }),

/***/ "./V7/events/listing/calendarView/CalendarModeBaseView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = __webpack_require__("./node_modules/babel-runtime/core-js/map.js");

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

var _EventListingViewClasses = __webpack_require__("./V7/events/listing/EventListingViewClasses.js");

var _EventListingViewClasses2 = _interopRequireDefault(_EventListingViewClasses);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

var _Loaders = __webpack_require__("./V7/events/listing/Loaders.js");

var _htmlShared = __webpack_require__("./V7/events/listing/htmlShared/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HTML = '\n  <div class="' + _EventListingViewClasses2.default.CONTROLS_CONTAINER + '"></div>\n  <div class="' + _EventListingViewClasses2.default.RESULTS_CONTAINER + '"></div>\n';

var CalendarResultBaseView = function () {
  function CalendarResultBaseView(store, config, mode) {
    var _this = this;

    (0, _classCallCheck3.default)(this, CalendarResultBaseView);

    this.store = store;
    this.config = config;
    this.mode = mode;
    this.isCurrentView = false;
    this.selectedDate = null;
    this.startDate = null;
    this.endDate = null;
    this.selectedDate = config.defaultDisplayDate;

    this.$el = (0, _jquery2.default)('#tn-events-calendar-view-' + mode);
    this.$el.html(HTML);
    this.$el.append((0, _htmlShared.makeBusyIndicatorHtml)());

    this.$results = this.$el.find('.' + _EventListingViewClasses2.default.RESULTS_CONTAINER);
    this.$controls = this.$el.find('.' + _EventListingViewClasses2.default.CONTROLS_CONTAINER);

    this.store.on('date', this.onSelectedDateUpdated.bind(this));
    this.store.on('mode', this.onModeUpdate.bind(this));

    this.store.on('fetchStart', function () {
      _this.$el.addClass(_EventListingViewClasses2.default.LOADING_MODIFIER);
    });

    this.store.on('fetchEnd', function () {
      _this.$el.removeClass(_EventListingViewClasses2.default.LOADING_MODIFIER);
    });

    this.store.on('fetchFailed', function () {
      _this.$el.removeClass(_EventListingViewClasses2.default.LOADING_MODIFIER);
      _this.resultViews.forEach(function (view) {
        return view.clearResults();
      });
    });

    (0, _Loaders.loadDatePicker)().then(function (DatePicker) {
      _this.initDatepicker(DatePicker, {
        date: config.defaultDisplayDate,
        minDate: config.earliestEventDate,
        maxDate: config.latestEventDate
      });

      _this.$controls.append(_this.datePicker.$el);
    });
  }

  (0, _createClass3.default)(CalendarResultBaseView, [{
    key: 'setResultViews',
    value: function setResultViews(views) {
      var _this2 = this;

      this.resultViews = views;
      this.resultViews.forEach(function (view) {
        return _this2.$results.append(view.$el);
      });
    }
  }, {
    key: 'onModeUpdate',
    value: function onModeUpdate(_ref) {
      var mode = _ref.mode;

      this.isCurrentView = this.mode === mode;

      if (this.isCurrentView) {
        this.show();
      }
    }
  }, {
    key: 'onDateChange',
    value: function onDateChange(date) {
      this.selectedDate = date;
      this.store.emit('date', { date: date });
    }
  }, {
    key: 'onSelectedDateUpdated',
    value: function onSelectedDateUpdated(_ref2) {
      var date = _ref2.date;

      this.selectedDate = date;
    }
  }, {
    key: 'setSelectedDate',
    value: function setSelectedDate(date) {
      if (this.datePicker) {
        this.datePicker.setDate(date);
      }
      this.onDateChange(date);
    }
  }, {
    key: 'show',
    value: function show() {
      this.setSelectedDate(this.selectedDate);
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.renderResults(data);
    }
  }, {
    key: 'renderResults',
    value: function renderResults(perfMap) {
      var _this3 = this;

      var _getRangeForSelectedD = this.getRangeForSelectedDate(),
          startDate = _getRangeForSelectedD.startDate,
          endDate = _getRangeForSelectedD.endDate;

      // Use only the perfs that fall within our viewing date range:


      var filteredPerfMap = new _map2.default();
      perfMap.forEach(function (perfs, key) {
        var perfDate = perfs[0].iso8601Date;
        if ((0, _DateHelpers.isBetweenDates)(perfDate, startDate, endDate)) {
          filteredPerfMap.set(key, perfs);
        }
      });

      this.resultViews.forEach(function (view) {
        return view.renderResults(filteredPerfMap, _this3.selectedDate);
      });
    }
  }]);
  return CalendarResultBaseView;
}();

exports.default = CalendarResultBaseView;

/***/ }),

/***/ "./V7/events/listing/calendarView/CalendarMonthView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _CalendarModeBaseView2 = __webpack_require__("./V7/events/listing/calendarView/CalendarModeBaseView.js");

var _CalendarModeBaseView3 = _interopRequireDefault(_CalendarModeBaseView2);

var _EventsCalendarViewMode = __webpack_require__("./V7/events/listing/calendarView/EventsCalendarViewMode.js");

var _EventsCalendarViewMode2 = _interopRequireDefault(_EventsCalendarViewMode);

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

var _EventMonthTable = __webpack_require__("./V7/events/listing/calendarView/html/EventMonthTable.js");

var _EventMonthTable2 = _interopRequireDefault(_EventMonthTable);

var _EventMonthList = __webpack_require__("./V7/events/listing/calendarView/html/EventMonthList.js");

var _EventMonthList2 = _interopRequireDefault(_EventMonthList);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarMonthView = function (_CalendarModeBaseView) {
  (0, _inherits3.default)(CalendarMonthView, _CalendarModeBaseView);

  function CalendarMonthView(store, config) {
    (0, _classCallCheck3.default)(this, CalendarMonthView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CalendarMonthView.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonthView)).call(this, store, config, _EventsCalendarViewMode2.default.MONTH));

    _this.setResultViews([new _EventMonthTable2.default(), new _EventMonthList2.default()]);
    return _this;
  }

  (0, _createClass3.default)(CalendarMonthView, [{
    key: 'initDatepicker',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(DatePicker, _ref) {
        var date = _ref.date,
            minDate = _ref.minDate,
            maxDate = _ref.maxDate;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.datePicker = new DatePicker({
                  date: date,
                  minDate: minDate,
                  maxDate: maxDate,
                  id: 'tn-event-calendar-input-month',
                  label: 'Select Month',
                  hideLabel: true,
                  rangeType: DatePicker.RangeType.MONTH,
                  dateFormatter: _EventListingDateFormatter2.default.month,
                  onChange: this.onDateChange.bind(this)
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initDatepicker(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return initDatepicker;
    }()
  }, {
    key: 'getRangeForSelectedDate',
    value: function getRangeForSelectedDate() {
      var date = this.selectedDate;


      return {
        startDate: (0, _DateHelpers.startOfWeek)((0, _DateHelpers.firstOfMonth)(date)),
        endDate: (0, _DateHelpers.endOfDay)((0, _DateHelpers.endOfWeek)((0, _DateHelpers.lastOfMonth)(date)))
      };
    }
  }]);
  return CalendarMonthView;
}(_CalendarModeBaseView3.default);

exports.default = CalendarMonthView;

/***/ }),

/***/ "./V7/events/listing/calendarView/CalendarWeekView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _CalendarModeBaseView2 = __webpack_require__("./V7/events/listing/calendarView/CalendarModeBaseView.js");

var _CalendarModeBaseView3 = _interopRequireDefault(_CalendarModeBaseView2);

var _EventsCalendarViewMode = __webpack_require__("./V7/events/listing/calendarView/EventsCalendarViewMode.js");

var _EventsCalendarViewMode2 = _interopRequireDefault(_EventsCalendarViewMode);

var _EventWeekTable = __webpack_require__("./V7/events/listing/calendarView/html/EventWeekTable.js");

var _EventWeekTable2 = _interopRequireDefault(_EventWeekTable);

var _EventWeekList = __webpack_require__("./V7/events/listing/calendarView/html/EventWeekList.js");

var _EventWeekList2 = _interopRequireDefault(_EventWeekList);

var _EventListingRangeFormatter = __webpack_require__("./V7/events/listing/date/EventListingRangeFormatter.js");

var _EventListingRangeFormatter2 = _interopRequireDefault(_EventListingRangeFormatter);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarWeekView = function (_CalendarModeBaseView) {
  (0, _inherits3.default)(CalendarWeekView, _CalendarModeBaseView);

  function CalendarWeekView(store, config) {
    (0, _classCallCheck3.default)(this, CalendarWeekView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CalendarWeekView.__proto__ || (0, _getPrototypeOf2.default)(CalendarWeekView)).call(this, store, config, _EventsCalendarViewMode2.default.WEEK));

    _this.setResultViews([new _EventWeekTable2.default(), new _EventWeekList2.default()]);
    return _this;
  }

  (0, _createClass3.default)(CalendarWeekView, [{
    key: 'initDatepicker',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(DatePicker, _ref) {
        var date = _ref.date,
            minDate = _ref.minDate,
            maxDate = _ref.maxDate;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.datePicker = new DatePicker({
                  date: date,
                  minDate: minDate,
                  maxDate: maxDate,
                  id: 'tn-event-calendar-input-week',
                  label: 'Select Week',
                  hideLabel: true,
                  rangeType: DatePicker.RangeType.WEEK,
                  dateFormatter: _EventListingRangeFormatter2.default.weekRange,
                  onChange: this.onDateChange.bind(this)
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initDatepicker(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return initDatepicker;
    }()
  }, {
    key: 'getRangeForSelectedDate',
    value: function getRangeForSelectedDate() {
      var date = this.selectedDate;


      return {
        startDate: (0, _DateHelpers.startOfWeek)(date),
        endDate: (0, _DateHelpers.endOfDay)((0, _DateHelpers.endOfWeek)(date))
      };
    }
  }]);
  return CalendarWeekView;
}(_CalendarModeBaseView3.default);

exports.default = CalendarWeekView;

/***/ }),

/***/ "./V7/events/listing/calendarView/EventsCalendarView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

var _map = __webpack_require__("./node_modules/babel-runtime/core-js/map.js");

var _map2 = _interopRequireDefault(_map);

var _EventListingPrimaryView = __webpack_require__("./V7/events/listing/EventListingPrimaryView.js");

var _EventListingPrimaryView2 = _interopRequireDefault(_EventListingPrimaryView);

var _EventListingViewMode = __webpack_require__("./V7/events/listing/EventListingViewMode.js");

var _EventListingViewMode2 = _interopRequireDefault(_EventListingViewMode);

var _EventsCalendarViewMode = __webpack_require__("./V7/events/listing/calendarView/EventsCalendarViewMode.js");

var _EventsCalendarViewMode2 = _interopRequireDefault(_EventsCalendarViewMode);

var _TabNav = __webpack_require__("./V7/events/listing/ui/TabNav.js");

var _TabNav2 = _interopRequireDefault(_TabNav);

var _DataStore = __webpack_require__("./V7/events/listing/api/DataStore.js");

var _DataStore2 = _interopRequireDefault(_DataStore);

var _CalendarMonthView = __webpack_require__("./V7/events/listing/calendarView/CalendarMonthView.js");

var _CalendarMonthView2 = _interopRequireDefault(_CalendarMonthView);

var _CalendarWeekView = __webpack_require__("./V7/events/listing/calendarView/CalendarWeekView.js");

var _CalendarWeekView2 = _interopRequireDefault(_CalendarWeekView);

var _CalendarDayView = __webpack_require__("./V7/events/listing/calendarView/CalendarDayView.js");

var _CalendarDayView2 = _interopRequireDefault(_CalendarDayView);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transform(data) {
  var perfsByDate = new _map2.default();

  data.productions.forEach(function (production) {
    production.performances.forEach(function (performance) {
      var key = (0, _DateHelpers.getISODateString)(performance.iso8601Date);
      var otherDayPerfs = perfsByDate.get(key) || [];

      otherDayPerfs.push(performance);
      perfsByDate.set(key, otherDayPerfs);
    });
  });

  perfsByDate.forEach(function (perfs) {
    perfs.sort(function (a, b) {
      return a.iso8601Date.getTime() - b.iso8601Date.getTime();
    });
  });

  var sortedPerfsByDate = new _map2.default();

  (0, _from2.default)(perfsByDate.keys()).sort().forEach(function (key) {
    sortedPerfsByDate.set(key, perfsByDate.get(key));
  });

  return sortedPerfsByDate;
}

var EventsCalendarView = function (_EventListingPrimaryV) {
  (0, _inherits3.default)(EventsCalendarView, _EventListingPrimaryV);

  function EventsCalendarView(config, keywordFilter, viewToggle) {
    var _this$childViews;

    (0, _classCallCheck3.default)(this, EventsCalendarView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventsCalendarView.__proto__ || (0, _getPrototypeOf2.default)(EventsCalendarView)).call(this, config, keywordFilter, viewToggle));

    _this.store = new _DataStore2.default(transform);

    _this.store.on('date', function () {
      if (_this.isVisible) {
        _this.fetchData();
      }
    });

    _this.childViews = (_this$childViews = {}, (0, _defineProperty3.default)(_this$childViews, _EventsCalendarViewMode2.default.MONTH, new _CalendarMonthView2.default(_this.store, config)), (0, _defineProperty3.default)(_this$childViews, _EventsCalendarViewMode2.default.WEEK, new _CalendarWeekView2.default(_this.store, config)), (0, _defineProperty3.default)(_this$childViews, _EventsCalendarViewMode2.default.DAY, new _CalendarDayView2.default(_this.store, config)), _this$childViews);

    var mode = config.calendarViewMode;

    _this.tabNav = new _TabNav2.default('#tn-events-calendar-mode-tab-nav', {
      mode: mode,
      activeClass: 'active',
      onChange: _this.setMode.bind(_this)
    });

    _this.setMode(mode);
    return _this;
  }

  (0, _createClass3.default)(EventsCalendarView, [{
    key: 'setMode',
    value: function setMode(mode) {
      if (mode !== this.mode) {
        this.mode = mode;
        this.store.emit('mode', { mode: mode });
      }
    }
  }, {
    key: 'getCurrentView',
    value: function getCurrentView() {
      return this.childViews[this.mode];
    }
  }]);
  return EventsCalendarView;
}(_EventListingPrimaryView2.default);

EventsCalendarView.ViewMode = _EventListingViewMode2.default.CALENDAR;

exports.default = EventsCalendarView;

/***/ }),

/***/ "./V7/events/listing/calendarView/EventsCalendarViewMode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month'
};

/***/ }),

/***/ "./V7/events/listing/calendarView/html/ClassNames.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ClassNames = {
  BASE: 'tn-events-calendar'
  // TABLE_HEADING: 'tn-events-calendar__table-heading',
};

exports.default = ClassNames;

/***/ }),

/***/ "./V7/events/listing/calendarView/html/EventDayList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _EventMonthList2 = __webpack_require__("./V7/events/listing/calendarView/html/EventMonthList.js");

var _EventMonthList3 = _interopRequireDefault(_EventMonthList2);

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDayList = function (_EventMonthList) {
  (0, _inherits3.default)(EventDayList, _EventMonthList);

  function EventDayList() {
    (0, _classCallCheck3.default)(this, EventDayList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventDayList.__proto__ || (0, _getPrototypeOf2.default)(EventDayList)).call(this));

    _this.resultsFormatter = _EventListingDateFormatter2.default.standardDate;
    _this.dayFormatter = _EventListingDateFormatter2.default.weekdayLabel;
    return _this;
  }

  return EventDayList;
}(_EventMonthList3.default);

exports.default = EventDayList;

/***/ }),

/***/ "./V7/events/listing/calendarView/html/EventMonthList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = __webpack_require__("./node_modules/babel-runtime/core-js/map.js");

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

var _ClassNames = __webpack_require__("./V7/events/listing/calendarView/html/ClassNames.js");

var _ClassNames2 = _interopRequireDefault(_ClassNames);

var _htmlShared = __webpack_require__("./V7/events/listing/htmlShared/index.js");

var _Performance = __webpack_require__("./V7/events/listing/calendarView/html/Performance.js");

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventMonthList = function () {
  function EventMonthList() {
    (0, _classCallCheck3.default)(this, EventMonthList);

    this.$el = (0, _jquery2.default)('<div class="' + _ClassNames2.default.BASE + '__list-container">');
    this.dayFormatter = _EventListingDateFormatter2.default.standardDate;
    this.resultsFormatter = _EventListingDateFormatter2.default.month;
  }

  (0, _createClass3.default)(EventMonthList, [{
    key: 'makeListHtml',
    value: function makeListHtml(date) {
      return (0, _htmlShared.makeResultsDateRangeHeading)(this.resultsFormatter(date));
    }
  }, {
    key: 'setupView',
    value: function setupView(date) {
      this.$el.append(this.makeListHtml(date));
    }

    /**
     * @param {Map} perfMap
     * @param {Date} date
     * @return {Map}
     */

  }, {
    key: 'filterResults',
    value: function filterResults(perfMap, date) {
      // We don't want to show any spillover events from
      // the previous or next months on list view
      var filtered = new _map2.default();

      perfMap.forEach(function (perfs, key) {
        var perfDate = perfs[0].iso8601Date;

        if (perfDate.getMonth() === date.getMonth()) {
          filtered.set(key, perfs);
        } else {
          // console.warn(`Skipping ${perfs.length} event(s) on '${perfDate}' in list month view`);
        }
      });

      return filtered;
    }
  }, {
    key: 'clearResults',
    value: function clearResults() {
      this.$el.html('');
    }

    /**
     * @param {Map} perfMap
     * @param {Date} date
     */

  }, {
    key: 'renderResults',
    value: function renderResults(perfMap, date) {
      var _this = this;

      this.$el.empty();

      var filteredPerfMap = this.filterResults(perfMap, date);

      if (filteredPerfMap.size > 0) {
        this.setupView(date);
        var $list = (0, _jquery2.default)('<ul class="' + _ClassNames2.default.BASE + '__list">');

        filteredPerfMap.forEach(function (dayPerfs) {
          var perfDate = dayPerfs[0].iso8601Date;

          var listHtml = (0, _Performance.makePerformanceListHtml)(dayPerfs);

          $list.append('\n          <li>\n            <h4 class="' + _ClassNames2.default.BASE + '__list-day-heading">' + _this.dayFormatter(perfDate) + '</h4>\n            ' + listHtml + '\n          </li>\n        ');
        });

        this.$el.append($list);
      } else {
        var noResultsHtml = (0, _htmlShared.makeNoResultsHtml)(this.resultsFormatter(date));
        this.$el.append(noResultsHtml);
      }
    }
  }]);
  return EventMonthList;
}();

exports.default = EventMonthList;

/***/ }),

/***/ "./V7/events/listing/calendarView/html/EventMonthTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _map = __webpack_require__("./node_modules/babel-runtime/core-js/map.js");

var _map2 = _interopRequireDefault(_map);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

var _calendarJs = __webpack_require__("./node_modules/calendar-js/index.js");

var _calendarJs2 = _interopRequireDefault(_calendarJs);

var _ClassNames = __webpack_require__("./V7/events/listing/calendarView/html/ClassNames.js");

var _ClassNames2 = _interopRequireDefault(_ClassNames);

var _Performance = __webpack_require__("./V7/events/listing/calendarView/html/Performance.js");

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

var _htmlShared = __webpack_require__("./V7/events/listing/htmlShared/index.js");

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calendarJs = new _calendarJs2.default();

var todayISODateString = void 0; // updated every render

/**
 * @param {Map} perfMap
 * @returns {Map}
 */
function filterResults(perfMap) {
  var filteredMap = new _map2.default();

  perfMap.forEach(function (perfs, key) {
    // Table view should not show performances that have
    // "Date Displayed" set to false
    var perfsWithDisplayDate = perfs.filter(function (perf) {
      return !!perf.displayDate;
    });
    if (perfsWithDisplayDate.length) {
      filteredMap.set(key, perfsWithDisplayDate);
    }
  });

  return filteredMap;
}

function makeCellHtml(data) {
  var day = data.day,
      dateKey = data.dateKey;

  var classes = [_ClassNames2.default.BASE + '__day-cell'];

  if (todayISODateString === dateKey) {
    classes.push(_ClassNames2.default.BASE + '__day-cell--today');
  } else {
    if (dateKey < todayISODateString) {
      classes.push(_ClassNames2.default.BASE + '__day-cell--past');
    }
    if (data.isInPrimaryMonth === false) {
      if (data.isInLastWeekOfPrimaryMonth) {
        classes.push(_ClassNames2.default.BASE + '__day-cell--next-month');
      } else {
        classes.push(_ClassNames2.default.BASE + '__day-cell--previous-month');
      }
    }
  }

  return '\n    <td class="' + classes.join(' ') + '" aria-label="' + _EventListingDateFormatter2.default.tableCellAriaLabel(data.date) + '">\n      <div class="' + _ClassNames2.default.BASE + '__day">\n        <span class="' + _ClassNames2.default.BASE + '__day-number" aria-hidden="true">' + day + '</span>\n      </div>\n    </td>\n  ';
}

var EventMonthTable = function () {
  function EventMonthTable() {
    (0, _classCallCheck3.default)(this, EventMonthTable);

    this.cellsByDate = new _map2.default();
    this.$el = (0, _jquery2.default)('<div class="' + _ClassNames2.default.BASE + '__table-container">');
    this.resultsFormatter = _EventListingDateFormatter2.default.month;
    this.thFormatter = _EventListingDateFormatter2.default.weekdayLabelAbbreviated;
  }

  (0, _createClass3.default)(EventMonthTable, [{
    key: 'makeTableHtml',
    value: function makeTableHtml(date) {
      var _this = this;

      var weekStart = (0, _DateHelpers.startOfWeek)(date);
      var year = weekStart.getFullYear();
      var month = weekStart.getMonth();
      var weekdayLabels = [0, 1, 2, 3, 4, 5, 6].map(function (weekdayIndex) {
        return _this.thFormatter(new Date(year, month, weekStart.getDate() + weekdayIndex));
      });

      return '\n      <table class="' + _ClassNames2.default.BASE + '__table">\n        <caption>\n          ' + (0, _htmlShared.makeResultsDateRangeHeading)(this.resultsFormatter(date)) + '\n        </caption>\n        <thead>\n          <tr>\n            <th>' + weekdayLabels[0] + '</th>\n            <th>' + weekdayLabels[1] + '</th>\n            <th>' + weekdayLabels[2] + '</th>\n            <th>' + weekdayLabels[3] + '</th>\n            <th>' + weekdayLabels[4] + '</th>\n            <th>' + weekdayLabels[5] + '</th>\n            <th>' + weekdayLabels[6] + '</th>\n          </tr>\n        </thead>\n        <tbody></tbody>\n      </table>\n    ';
    }
  }, {
    key: 'getWeeksStructure',
    value: function getWeeksStructure(date) {
      var year = date.getFullYear();
      var month = date.getMonth();

      var detailed = calendarJs.detailed(year, month, function (dayData, calendar) {
        return (0, _assign2.default)({
          dateKey: (0, _DateHelpers.getISODateString)(dayData.date)
        }, dayData);
      });

      return detailed.calendar;
    }
  }, {
    key: 'setupView',
    value: function setupView(date) {
      var _this2 = this;

      var weeks = this.getWeeksStructure(date);

      var $tableContents = (0, _jquery2.default)(this.makeTableHtml(date));
      var $tbody = $tableContents.find('tbody');

      this.cellsByDate.clear();

      weeks.forEach(function (week) {
        var cells = [];

        week.forEach(function (day) {
          var $cell = (0, _jquery2.default)(makeCellHtml(day));

          _this2.cellsByDate.set(day.dateKey, $cell);

          cells.push($cell);
        });

        var $row = (0, _jquery2.default)('<tr>');
        $row.append(cells);

        $tbody.append($row);
      });

      this.$el.append($tableContents);
    }
  }, {
    key: 'clearResults',
    value: function clearResults() {
      this.$el.html('');
    }

    /**
     * @param {Map} perfMap
     * @param {Date} date
     */

  }, {
    key: 'renderResults',
    value: function renderResults(perfMap, date) {
      var _this3 = this;

      this.$el.empty();
      todayISODateString = (0, _DateHelpers.getISODateString)(new Date());
      // todayISODateString = '2018-01-10';

      var filteredPerfMap = filterResults(perfMap);

      if (filteredPerfMap.size > 0) {
        this.setupView(date);

        filteredPerfMap.forEach(function (dayPerfs, key) {
          var $cell = _this3.cellsByDate.get(key);
          if ($cell) {
            var listHtml = (0, _Performance.makePerformanceListHtml)(dayPerfs);
            $cell.find('.' + _ClassNames2.default.BASE + '__day').append(listHtml);
          }
        });
      } else {
        var noResultsHtml = (0, _htmlShared.makeNoResultsHtml)(this.resultsFormatter(date));
        this.$el.append(noResultsHtml);
      }
    }
  }]);
  return EventMonthTable;
}();

exports.default = EventMonthTable;

/***/ }),

/***/ "./V7/events/listing/calendarView/html/EventWeekList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _EventMonthList2 = __webpack_require__("./V7/events/listing/calendarView/html/EventMonthList.js");

var _EventMonthList3 = _interopRequireDefault(_EventMonthList2);

var _EventListingRangeFormatter = __webpack_require__("./V7/events/listing/date/EventListingRangeFormatter.js");

var _EventListingRangeFormatter2 = _interopRequireDefault(_EventListingRangeFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventWeekList = function (_EventMonthList) {
  (0, _inherits3.default)(EventWeekList, _EventMonthList);

  function EventWeekList() {
    (0, _classCallCheck3.default)(this, EventWeekList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventWeekList.__proto__ || (0, _getPrototypeOf2.default)(EventWeekList)).call(this));

    _this.resultsFormatter = _EventListingRangeFormatter2.default.weekRange;
    return _this;
  }

  (0, _createClass3.default)(EventWeekList, [{
    key: 'filterResults',
    value: function filterResults(perfMap, date) {
      // On week view we *do* want to show the prev/next
      // month's spillover. No additional filtering needed
      return perfMap;
    }
  }]);
  return EventWeekList;
}(_EventMonthList3.default);

exports.default = EventWeekList;

/***/ }),

/***/ "./V7/events/listing/calendarView/html/EventWeekTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__("./node_modules/babel-runtime/helpers/get.js");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _EventMonthTable2 = __webpack_require__("./V7/events/listing/calendarView/html/EventMonthTable.js");

var _EventMonthTable3 = _interopRequireDefault(_EventMonthTable2);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

var _EventListingRangeFormatter = __webpack_require__("./V7/events/listing/date/EventListingRangeFormatter.js");

var _EventListingRangeFormatter2 = _interopRequireDefault(_EventListingRangeFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventWeekTable = function (_EventMonthTable) {
  (0, _inherits3.default)(EventWeekTable, _EventMonthTable);

  function EventWeekTable() {
    (0, _classCallCheck3.default)(this, EventWeekTable);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventWeekTable.__proto__ || (0, _getPrototypeOf2.default)(EventWeekTable)).call(this));

    _this.resultsFormatter = _EventListingRangeFormatter2.default.weekRange;
    _this.thFormatter = _EventListingDateFormatter2.default.weekdayDate;
    return _this;
  }

  (0, _createClass3.default)(EventWeekTable, [{
    key: 'getWeeksStructure',
    value: function getWeeksStructure(date) {
      var weeks = (0, _get3.default)(EventWeekTable.prototype.__proto__ || (0, _getPrototypeOf2.default)(EventWeekTable.prototype), 'getWeeksStructure', this).call(this, date);
      var dateTime = (0, _DateHelpers.startOfWeek)(date).getTime();

      return weeks.filter(function (week) {
        return (0, _DateHelpers.startOfWeek)(week[0].date).getTime() === dateTime;
      });
    }
  }]);
  return EventWeekTable;
}(_EventMonthTable3.default);

exports.default = EventWeekTable;

/***/ }),

/***/ "./V7/events/listing/calendarView/html/Performance.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePerformanceListHtml = exports.makePerformanceListItemHtml = undefined;

var _ClassNames = __webpack_require__("./V7/events/listing/calendarView/html/ClassNames.js");

var _ClassNames2 = _interopRequireDefault(_ClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makePerformanceListItemHtml(data) {
  var actionUrl = data.actionUrl,
      performanceTitle = data.performanceTitle,
      displayTime = data.displayTime,
      performanceStatusMessage = data.performanceStatusMessage;


  return '\n    <li class="' + _ClassNames2.default.BASE + '__day-event-list-item">\n      <a href="' + actionUrl + '" class="' + _ClassNames2.default.BASE + '__event btn btn-primary">\n        <span class="' + _ClassNames2.default.BASE + '__event-name">' + performanceTitle + '</span>\n        <span class="' + _ClassNames2.default.BASE + '__event-time">\n          <span class="sr-only">, </span>' + displayTime + '</span>\n        </span>\n        ' + (performanceStatusMessage ? '\n          <span class="' + _ClassNames2.default.BASE + '__event-status">\n            <span class="sr-only">, </span>' + performanceStatusMessage + '\n          </span>\n        ' : '') + '\n      </a>\n    </li>\n  ';
}

function makePerformanceListHtml(perfs) {
  var listItems = perfs.map(function (perf) {
    return makePerformanceListItemHtml(perf);
  });

  return '\n    <ul class="' + _ClassNames2.default.BASE + '__day-event-list">\n      ' + listItems.join('') + '\n    </ul>\n  ';
}

exports.makePerformanceListItemHtml = makePerformanceListItemHtml;
exports.makePerformanceListHtml = makePerformanceListHtml;

/***/ }),

/***/ "./V7/events/listing/date/DateFormatter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatISOBasic = exports.format = undefined;

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

var _map = __webpack_require__("./node_modules/babel-runtime/core-js/map.js");

var _map2 = _interopRequireDefault(_map);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @param {Number} number
* @returns {string}
*/
function ordinal(number) {
  if (number > 3 && number < 21) return number + 'th';

  var mod = number % 10;
  if (mod === 1) return number + 'st';
  if (mod === 2) return number + 'nd';
  if (mod === 3) return number + 'rd';
  return number + 'th';
}

var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var tokenMap = new _map2.default([
// This is an *INCOMPLETE* implementation of moment's
// formatting tokens. Token order in this map is important -
// the tokens/keys are used to build the regex, so make sure
// they're most-to-least specific.

// https://momentjs.com/docs/#/displaying/

// Month
['MMMM', function (date) {
  return months[date.getMonth()];
}], ['MMM', function (date) {
  return months[date.getMonth()].substr(0, 3);
}], ['MM', function (date) {
  return (0, _DateHelpers.padNumber)(date.getMonth() + 1);
}], ['Mo', function (date) {
  return ordinal(date.getMonth() + 1);
}], ['M', function (date) {
  return date.getMonth() + 1;
}],

// Quarter
['Qo', function (date) {
  return ordinal(Math.floor((date.getMonth() + 3) / 3));
}], ['Q', function (date) {
  return Math.floor((date.getMonth() + 3) / 3);
}],

// Day of Month
['DD', function (date) {
  return (0, _DateHelpers.padNumber)(date.getDate());
}], ['Do', function (date) {
  return ordinal(date.getDate());
}], ['D', function (date) {
  return date.getDate();
}],

// Day of Week
['dddd', function (date) {
  return weekdays[date.getDay()];
}], ['ddd', function (date) {
  return weekdays[date.getDay()].substr(0, 3);
}], ['dd', function (date) {
  return weekdays[date.getDay()].substr(0, 2);
}], ['do', function (date) {
  return ordinal(date.getDay());
}], ['d', function (date) {
  return date.getDay();
}],

// Year
['YYYY', function (date) {
  return date.getFullYear();
}], ['YY', function (date) {
  return date.getFullYear().toString().slice(2, 4);
}],

// AM/PM
['A', function (date) {
  return date.getHours() < 12 ? 'AM' : 'PM';
}], ['a', function (date) {
  return date.getHours() < 12 ? 'am' : 'pm';
}],

// Hour
['HH', function (date) {
  return (0, _DateHelpers.padNumber)(date.getHours());
}], ['H', function (date) {
  return date.getHours();
}], ['hh', function (date) {
  return (0, _DateHelpers.padNumber)(date.getHours() % 12 + 1);
}], ['h', function (date) {
  return date.getHours() % 12 + 1;
}], ['kk', function (date) {
  return (0, _DateHelpers.padNumber)(date.getHours() + 1);
}], ['k', function (date) {
  return date.getHours() + 1;
}],

// Minute
['mm', function (date) {
  return (0, _DateHelpers.padNumber)(date.getMinutes());
}], ['m', function (date) {
  return date.getMinutes();
}],

// Second
['ss', function (date) {
  return (0, _DateHelpers.padNumber)(date.getSeconds());
}], ['s', function (date) {
  return date.getSeconds();
}],

// Time Zone
['Z', function (date) {
  var offset = date.getTimezoneOffset();

  if (offset === 0) {
    return 'Z';
  }

  var plusMinus = offset < 0 ? '+' : '-';
  var hours = Math.floor(Math.abs(offset) / 60);
  var minutes = Math.abs(offset) % 60;

  return '' + plusMinus + (0, _DateHelpers.padNumber)(hours) + ':' + (0, _DateHelpers.padNumber)(minutes);
}]]);

var regex = new RegExp([
// Escapes characters surrounded by brackets:
'\\[([^\\]]+)\\]',

// Match any token:
'(' + (0, _from2.default)(tokenMap.keys()).join('|') + ')',

// Match anything else to pass-through
'.'].join('|'), 'g');

var ReplacementToken = function () {
  function ReplacementToken(token, fn) {
    (0, _classCallCheck3.default)(this, ReplacementToken);

    this.token = token;
    this.fn = fn;
  }

  (0, _createClass3.default)(ReplacementToken, [{
    key: 'getValue',
    value: function getValue(date) {
      return this.fn(date);
    }
  }]);
  return ReplacementToken;
}();

var PassThroughString = function () {
  function PassThroughString(value) {
    (0, _classCallCheck3.default)(this, PassThroughString);

    this.value = value;
  }

  (0, _createClass3.default)(PassThroughString, [{
    key: 'append',
    value: function append(value) {
      this.value += value;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.value;
    }
  }]);
  return PassThroughString;
}();

/**
 * @param {string} picture
 * @returns {Array.<ReplacementToken|PassThroughString>}
 */


function parsePictureString(picture) {
  var pieces = [];
  var m = void 0;

  while ((m = regex.exec(picture)) !== null) {
    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex += 1;
    }

    var stringValue = null;
    var bracketEscapedValue = m[1];

    if (bracketEscapedValue) {
      stringValue = bracketEscapedValue;
    } else {
      var token = m[0];
      var fn = tokenMap.get(token);
      if (fn) {
        pieces.push(new ReplacementToken(token, fn));
      } else {
        stringValue = token;
      }
    }

    if (stringValue !== null) {
      var lastAddedPiece = pieces[pieces.length - 1];
      if (lastAddedPiece instanceof PassThroughString) {
        lastAddedPiece.append(stringValue);
      } else {
        pieces.push(new PassThroughString(stringValue));
      }
    }
  }

  return pieces;
}

var DateFormatPicture = function () {
  /**
   * @param {String} picture
   */
  function DateFormatPicture(picture) {
    (0, _classCallCheck3.default)(this, DateFormatPicture);

    /**
     * @type {Array.<ReplacementToken|PassThroughString>}
     */
    this.pieces = parsePictureString(picture);
  }

  /**
   * @param {Date} date
   * @returns {string}
   */


  (0, _createClass3.default)(DateFormatPicture, [{
    key: 'format',
    value: function format(date) {
      return this.pieces.reduce(function (value, piece) {
        return value + piece.getValue(date);
      }, '');
    }
  }]);
  return DateFormatPicture;
}();

/**
 * @type {Map.<string, DateFormatPicture>}
 */


var instanceMap = new _map2.default();

/**
 * @param {string} picture
 * @returns {DateFormatPicture}
 */
function getPictureInstance(picture) {
  var instance = instanceMap.get(picture);

  if (!instance) {
    instance = new DateFormatPicture(picture);
    instanceMap.set(picture, instance);
  }

  return instance;
}

/**
 * @param {Date} date
 * @param {string} picture
 * @returns {string}
 */
function format(date, picture) {
  return getPictureInstance(picture).format(date);
}

/**
 * @param {Date} date
 * @returns {string}
 */
function formatISOBasic(date) {
  return format(date, 'YYYY-MM-DDTHH:mm:ssZ');
}

exports.format = format;
exports.formatISOBasic = formatISOBasic;

/***/ }),

/***/ "./V7/events/listing/date/DateHelpers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseYYYYMMDD = exports.startOfDay = exports.endOfDay = exports.areAdjacentMonths = exports.areDifferentDays = exports.areDifferentMonths = exports.areDifferentYears = exports.areSameDay = exports.areSameMonth = exports.areSameYear = exports.isBetweenDates = exports.constrainDate = exports.endOfWeek = exports.startOfWeek = exports.padNumber = exports.getISODateTimeString = exports.getISODateString = exports.getMonthRange = exports.getWeekRange = exports.nextMonth = exports.previousMonth = exports.nextWeek = exports.previousWeek = exports.nextDay = exports.previousDay = exports.lastOfMonth = exports.firstOfMonth = undefined;

var _slicedToArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/slicedToArray.js");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @param {Date} date
* @returns {Date}
*/
function startOfWeek(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay());
}

/**
* @param {Date} date
* @returns {Date}
*/
function endOfWeek(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + (6 - date.getDay()));
}

/**
* @param {Date} date
* @returns {Date}
*/
function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

/**
* @param {Date} date
* @returns {Date}
*/
function endOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

/**
* @param {Date} date
* @returns {Date}
*/
function firstOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth());
}

/**
* @param {Date} date
* @returns {Date}
*/
function lastOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

/**
* @param {Date} date
* @returns {Date}
*/
function previousMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() - 1);
}

/**
* @param {Date} date
* @returns {Date}
*/
function nextMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1);
}

/**
* @param {Date} date
* @returns {Date}
*/
function previousWeek(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 7);
}

/**
* @param {Date} date
* @returns {Date}
*/
function nextWeek(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7);
}

/**
* @param {Date} date
* @returns {Date}
*/
function previousDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
}

/**
* @param {Date} date
* @returns {Date}
*/
function nextDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
}

/**
* @param {Date} startDate
* @param {Date} endDate
* @returns {Date[]}
*/
function buildRange(startDate, endDate, dateIncrementer) {
  if (startDate > endDate) {
    throw new Error();
  }

  var dates = [startDate];

  if (startDate.getTime() === endDate.getTime()) {
    return dates;
  }

  var next = dateIncrementer(startDate);
  while (next.getTime() < endDate.getTime()) {
    dates.push(next);
    next = dateIncrementer(next);
  }
  dates.push(endDate);

  return dates;
}

/**
* @param {Date} startDate
* @param {Date} endDate
* @returns {Date[]}
*/
function getMonthRange(startDate, endDate) {
  var startMonth = firstOfMonth(startDate);
  var endMonth = firstOfMonth(endDate);

  return buildRange(startMonth, endMonth, nextMonth);
}

/**
* @param {Date} startDate
* @param {Date} endDate
* @returns {Date[]}
*/
function getWeekRange(startDate, endDate) {
  var startWeek = startOfWeek(startDate);
  var endWeek = startOfWeek(endDate);

  return buildRange(startWeek, endWeek, nextWeek);
}

/**
* @param {Number} number
* @param {Number} padTo
* @returns {string}
*/
function padNumber(number) {
  var padTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  return ('' + number).padStart(padTo, '0');
}

/**
* @param {Date} date
* @returns {string}
*/
function getISODateString(date) {
  return date.getFullYear() + '-' + padNumber(date.getMonth() + 1) + '-' + padNumber(date.getDate());
}

/**
* @param {Date} date
* @returns {string}
*/
function getISODateTimeString(date) {
  return getISODateString(date) + 'T00:00:00Z';
}

/**
* @param {Date} date
* @param {Date|null} minDate
* @param {Date|null} maxDate
* @returns {Date}
*/
function constrainDate(date) {
  var minDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var maxDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var time = date.getTime();
  var min = minDate === null ? -Infinity : minDate.getTime();
  var max = maxDate === null ? Infinity : maxDate.getTime();

  if (time < min) time = min;
  if (time > max) time = max;

  return new Date(time);
}

/**
* @param {string} string
* @returns {Date|null}
*/
function parseYYYYMMDD(string) {
  var regex = /^(\d{4})-(\d{2})-(\d{2})/;
  var matches = regex.exec(string);

  if (matches) {
    var _matches = (0, _slicedToArray3.default)(matches, 4),
        fullMatch = _matches[0],
        year = _matches[1],
        month = _matches[2],
        day = _matches[3];

    var date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));

    return date;
  }

  return null;
}

/**
* @param {Date} date
* @param {Date} startDate
* @param {Date} endDate
* @returns {boolean}
*/
function isBetweenDates(date, startDate, endDate) {
  var time = date.getTime();
  if (time < startDate.getTime()) return false;
  if (time > endDate.getTime()) return false;
  return true;
}

/**
* @param {Date} date1
* @param {Date} date2
* @returns {boolean}
*/
function areAdjacentMonths(date1, date2) {
  var month1 = date1.getFullYear() * 12 + date1.getMonth();
  var month2 = date2.getFullYear() * 12 + date2.getMonth();

  return Math.abs(month1 - month2) === 1;
}

/**
* @param {Date} date1
* @param {Date} date2
* @returns {boolean}
*/
function areSameYear(date1, date2) {
  return date1.getFullYear() === date2.getFullYear();
}

/**
* @param {Date} date1
* @param {Date} date2
* @returns {boolean}
*/
function areDifferentYears(date1, date2) {
  return !areSameYear(date1, date2);
}

/**
* @param {Date} date1
* @param {Date} date2
* @returns {boolean}
*/
function areSameMonth(date1, date2) {
  return areSameYear(date1, date2) && date1.getMonth() === date2.getMonth();
}

/**
* @param {Date} date1
* @param {Date} date2
* @returns {boolean}
*/
function areDifferentMonths(date1, date2) {
  return !areSameMonth(date1, date2);
}

/**
* @param {Date} date1
* @param {Date} date2
* @returns {boolean}
*/
function areSameDay(date1, date2) {
  return areSameMonth(date1, date2) && date1.getDate() === date2.getDate();
}

/**
* @param {Date} date1
* @param {Date} date2
* @returns {boolean}
*/
function areDifferentDays(date1, date2) {
  return !areSameDay(date1, date2);
}

exports.firstOfMonth = firstOfMonth;
exports.lastOfMonth = lastOfMonth;
exports.previousDay = previousDay;
exports.nextDay = nextDay;
exports.previousWeek = previousWeek;
exports.nextWeek = nextWeek;
exports.previousMonth = previousMonth;
exports.nextMonth = nextMonth;
exports.getWeekRange = getWeekRange;
exports.getMonthRange = getMonthRange;
exports.getISODateString = getISODateString;
exports.getISODateTimeString = getISODateTimeString;
exports.padNumber = padNumber;
exports.startOfWeek = startOfWeek;
exports.endOfWeek = endOfWeek;
exports.constrainDate = constrainDate;
exports.isBetweenDates = isBetweenDates;
exports.areSameYear = areSameYear;
exports.areSameMonth = areSameMonth;
exports.areSameDay = areSameDay;
exports.areDifferentYears = areDifferentYears;
exports.areDifferentMonths = areDifferentMonths;
exports.areDifferentDays = areDifferentDays;
exports.areAdjacentMonths = areAdjacentMonths;
exports.endOfDay = endOfDay;
exports.startOfDay = startOfDay;
exports.parseYYYYMMDD = parseYYYYMMDD;

/***/ }),

/***/ "./V7/events/listing/date/EventListingDateFormat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  STANDARD_DATE: 1,
  WEEKDAY_DATE: 2,
  MONTH: 3,
  WEEKDAY_LABEL: 4,
  WEEKDAY_LABEL_ABBR: 5,
  TABLE_CELL_ARIA_LABEL: 6
};

/***/ }),

/***/ "./V7/events/listing/date/EventListingDateFormatter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _defaultFormats;

var _DateFormatter = __webpack_require__("./V7/events/listing/date/DateFormatter.js");

var _EventListingDateFormat = __webpack_require__("./V7/events/listing/date/EventListingDateFormat.js");

var _EventListingDateFormat2 = _interopRequireDefault(_EventListingDateFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultFormats = (_defaultFormats = {}, (0, _defineProperty3.default)(_defaultFormats, _EventListingDateFormat2.default.STANDARD_DATE, 'MMMM D, YYYY'), (0, _defineProperty3.default)(_defaultFormats, _EventListingDateFormat2.default.WEEKDAY_DATE, 'ddd, MMM D'), (0, _defineProperty3.default)(_defaultFormats, _EventListingDateFormat2.default.MONTH, 'MMMM YYYY'), (0, _defineProperty3.default)(_defaultFormats, _EventListingDateFormat2.default.WEEKDAY_LABEL, 'dddd'), (0, _defineProperty3.default)(_defaultFormats, _EventListingDateFormat2.default.WEEKDAY_LABEL_ABBR, 'ddd'), (0, _defineProperty3.default)(_defaultFormats, _EventListingDateFormat2.default.TABLE_CELL_ARIA_LABEL, 'D, dddd MMMM YYYY'), _defaultFormats);

var formats = defaultFormats;

function setDateFormats() {
  var settingFormats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  formats = (0, _assign2.default)({}, defaultFormats, settingFormats);
}

function standardDate(date) {
  return (0, _DateFormatter.format)(date, formats[_EventListingDateFormat2.default.STANDARD_DATE]);
}

function weekdayDate(date) {
  return (0, _DateFormatter.format)(date, formats[_EventListingDateFormat2.default.WEEKDAY_DATE]);
}

function month(date) {
  return (0, _DateFormatter.format)(date, formats[_EventListingDateFormat2.default.MONTH]);
}

function weekdayLabel(date) {
  return (0, _DateFormatter.format)(date, formats[_EventListingDateFormat2.default.WEEKDAY_LABEL]);
}

function weekdayLabelAbbreviated(date) {
  return (0, _DateFormatter.format)(date, formats[_EventListingDateFormat2.default.WEEKDAY_LABEL_ABBR]);
}

function tableCellAriaLabel(date) {
  return (0, _DateFormatter.format)(date, formats[_EventListingDateFormat2.default.TABLE_CELL_ARIA_LABEL]);
}

function getStandardDateFormat() {
  return formats[_EventListingDateFormat2.default.STANDARD_DATE];
}

exports.default = {
  setDateFormats: setDateFormats,
  getStandardDateFormat: getStandardDateFormat,
  standardDate: standardDate,
  format: _DateFormatter.format,
  weekdayDate: weekdayDate,
  month: month,
  weekdayLabel: weekdayLabel,
  weekdayLabelAbbreviated: weekdayLabelAbbreviated,
  tableCellAriaLabel: tableCellAriaLabel
};

/***/ }),

/***/ "./V7/events/listing/date/EventListingRangeFormatter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rangeFormat = null;
function getRangeFormat() {
  if (rangeFormat === null) {
    var dateFormat = _EventListingDateFormatter2.default.getStandardDateFormat();

    var rangeFormats = {
      'MMMM D, YYYY': { md: 'MMM D', ymd: 'MMM D, YYYY', dy: 'D, YYYY' },
      'MMM D, YYYY': { md: 'MMM D', ymd: 'MMM D, YYYY', dy: 'D, YYYY' },
      'MMM DD, YYYY': { md: 'MMM DD', ymd: 'MMM DD, YYYY', dy: 'DD, YYYY' },
      'D MMMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'D MMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'DD MMM YYYY': { md: 'DD MMM', ymd: 'DD MMM YYYY', dy: 'DD MMM YYYY' },
      'DD/MM/YYYY': { md: 'DD/MM', ymd: 'DD/MM/YYYY', dy: 'DD/MM/YYYY' },
      'MM/DD/YYYY': { md: 'MM/DD', ymd: 'MM/DD/YYYY', dy: 'MM/DD/YYYY' },
      'ddd DD/MM/YYYY': { md: 'DD/MM', ymd: 'DD/MM/YYYY', dy: 'DD/MM/YYYY' },
      'ddd MM/DD/YYYY': { md: 'MM/DD', ymd: 'MM/DD/YYYY', dy: 'MM/DD/YYYY' },
      'dddd D MMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'dddd D MMMM YYYY': { md: 'D MMM', ymd: 'D MMM YYYY', dy: 'D MMM YYYY' },
      'dddd DD MMM YYYY': { md: 'DD MMM', ymd: 'DD MMM YYYY', dy: 'DD MMM YYYY' },
      'dddd, MMM D, YYYY': { md: 'MMM D', ymd: 'MMM D, YYYY', dy: 'D, YYYY' }
    };

    rangeFormat = rangeFormats[dateFormat];

    if (!rangeFormat) {
      console.warn('Defaulting EventListing date range formats for dateFormat \'' + dateFormat + '\'');
      rangeFormat = rangeFormats['MMMM D, YYYY'];
    }
  }
  return rangeFormat;
}

function getFormatsForDateRange(from, to) {
  var _getRangeFormat = getRangeFormat(),
      ymd = _getRangeFormat.ymd,
      md = _getRangeFormat.md,
      dy = _getRangeFormat.dy;

  if ((0, _DateHelpers.areSameMonth)(from, to)) {
    // Dec 3 – 9, 2017
    return [md, dy];
  }

  if ((0, _DateHelpers.areSameYear)(from, to) || (0, _DateHelpers.areAdjacentMonths)(from, to)) {
    // Jan 28 – Feb 3, 2018
    return [md, ymd];
  }

  // Dec 31, 2017 – Jan 6, 2018
  return [ymd, ymd];
}

function range(from, to) {
  if ((0, _DateHelpers.areSameDay)(from, to)) {
    return _EventListingDateFormatter2.default.standardDate(from);
  }

  var rangeFormats = getFormatsForDateRange(from, to);
  var format = _EventListingDateFormatter2.default.format;


  return format(from, rangeFormats[0]) + ' \u2013 ' + format(to, rangeFormats[1]);
}

function weekRange(date) {
  return range((0, _DateHelpers.startOfWeek)(date), (0, _DateHelpers.endOfWeek)(date));
}

exports.default = {
  range: range,
  weekRange: weekRange
};

/***/ }),

/***/ "./V7/events/listing/htmlShared/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeBusyIndicatorHtml = exports.makeResultsDateRangeHeading = exports.makeNoResultsHtml = undefined;

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

var _EventListingViewClasses = __webpack_require__("./V7/events/listing/EventListingViewClasses.js");

var _EventListingViewClasses2 = _interopRequireDefault(_EventListingViewClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeResultsDateRangeHeading(formattedDateString) {
  if (formattedDateString === '') {
    return '<h3 class="sr-only">Results</h3>';
  }

  return '<h3 tabindex="0" class="' + _EventListingViewClasses2.default.RESULTS_HEADING + '">' + formattedDateString + '</h3>';
}

function makeNoResultsHtml(formattedDateString) {
  return '\n    ' + makeResultsDateRangeHeading(formattedDateString) + '\n    <div class="' + _EventListingViewClasses2.default.BASE + '__no-results-container">\n      <div class="' + _EventListingViewClasses2.default.BASE + '__no-results-content">\n        ' + (0, _jquery2.default)('#tn-event-listing-no-results-message-template').html() + '\n      </div>\n    </div>\n  ';
}

var busyIndicatorMessage = void 0;

function makeBusyIndicatorHtml() {
  if (!busyIndicatorMessage) {
    busyIndicatorMessage = (0, _jquery2.default)('#tn-event-listing-loading-message-template').html();
  }

  return '\n    <div class="tn-event-listing-busy-indicator">\n      <div class="tn-event-listing-busy-indicator__content">' + busyIndicatorMessage + '</div>\n    </div>\n  ';
}

exports.makeNoResultsHtml = makeNoResultsHtml;
exports.makeResultsDateRangeHeading = makeResultsDateRangeHeading;
exports.makeBusyIndicatorHtml = makeBusyIndicatorHtml;

/***/ }),

/***/ "./V7/events/listing/listView/EventsListControls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("./node_modules/babel-runtime/helpers/asyncToGenerator.js");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

var _events = __webpack_require__("./node_modules/events/events.js");

var _events2 = _interopRequireDefault(_events);

var _EventsListViewClasses = __webpack_require__("./V7/events/listing/listView/EventsListViewClasses.js");

var _EventsListViewClasses2 = _interopRequireDefault(_EventsListViewClasses);

var _Loaders = __webpack_require__("./V7/events/listing/Loaders.js");

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

var _EventListingDateFormatter = __webpack_require__("./V7/events/listing/date/EventListingDateFormatter.js");

var _EventListingDateFormatter2 = _interopRequireDefault(_EventListingDateFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventListControls = function (_EventEmitter) {
  (0, _inherits3.default)(EventListControls, _EventEmitter);

  function EventListControls(_ref) {
    var hideListViewControls = _ref.hideListViewControls,
        earliestEventDate = _ref.earliestEventDate,
        latestEventDate = _ref.latestEventDate,
        defaultDisplayDate = _ref.defaultDisplayDate,
        label = _ref.label,
        listingStartDate = _ref.listingStartDate,
        listingEndDate = _ref.listingEndDate;
    (0, _classCallCheck3.default)(this, EventListControls);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventListControls.__proto__ || (0, _getPrototypeOf2.default)(EventListControls)).call(this));

    _this.minDate = earliestEventDate;
    _this.maxDate = latestEventDate;

    _this.dateFrom = listingStartDate;
    _this.dateTo = listingEndDate;

    _this.initialDateFrom = _this.dateFrom;
    _this.initialDateTo = _this.dateTo;

    if (hideListViewControls) {
      return (0, _possibleConstructorReturn3.default)(_this);
    }

    var html = (0, _jquery2.default)('#tn-events-list-view-controls-template').html();
    _this.$el = (0, _jquery2.default)(html);

    _this.$btnReset = _this.$el.find('.' + _EventsListViewClasses2.default.BTN_RESET);
    _this.$btnReset.on('click', _this.resetDates.bind(_this));

    _this.init(label.listView);
    return _this;
  }

  (0, _createClass3.default)(EventListControls, [{
    key: 'init',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var _this2 = this;

        var inputDateTo = _ref2.inputDateTo,
            inputDateFrom = _ref2.inputDateFrom;
        var DatePicker, dateFrom, dateTo, minDate, maxDate;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _Loaders.loadDatePicker)();

              case 2:
                DatePicker = _context.sent;
                dateFrom = this.dateFrom, dateTo = this.dateTo, minDate = this.minDate, maxDate = this.maxDate;


                this.onDateChanged = this.onDateChanged.bind(this);

                this.datePickerFrom = new DatePicker({
                  minDate: minDate,
                  maxDate: maxDate,
                  date: dateFrom,
                  label: inputDateFrom,
                  dateFormatter: _EventListingDateFormatter2.default.standardDate,
                  hideLabel: true,
                  id: 'tn-event-list-input-date-from',
                  container: this.$el.find('.' + _EventsListViewClasses2.default.INPUT_CONTAINER_FROM),
                  onChange: function onChange(date) {
                    _this2.dateFrom = date;
                    _this2.onDateChanged();
                  }
                });

                this.datePickerTo = new DatePicker({
                  minDate: dateFrom,
                  maxDate: maxDate,
                  date: dateTo,
                  label: inputDateTo,
                  dateFormatter: _EventListingDateFormatter2.default.standardDate,
                  hideLabel: true,
                  id: 'tn-event-list-input-date-to',
                  container: this.$el.find('.' + _EventsListViewClasses2.default.INPUT_CONTAINER_TO),
                  onChange: function onChange(date) {
                    _this2.dateTo = date;
                    _this2.onDateChanged();
                  }
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x) {
        return _ref3.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: 'resetDates',
    value: function resetDates() {
      this.dateFrom = this.initialDateFrom;
      this.dateTo = this.initialDateTo;

      this.datePickerFrom.setDates({
        date: this.dateFrom,
        minDate: this.minDate,
        maxDate: this.maxDate
      });

      this.datePickerTo.setDates({
        date: this.dateTo,
        minDate: this.dateFrom,
        maxDate: this.maxDate
      });

      this.onDateChanged();
    }
  }, {
    key: 'onDateChanged',
    value: function onDateChanged() {
      var dateFrom = this.dateFrom,
          dateTo = this.dateTo;


      this.datePickerFrom.setMaxDate(dateTo);
      this.datePickerTo.setMinDate(dateFrom);

      this.updateBtnReset();

      this.dispatchUpdate();
    }
  }, {
    key: 'updateBtnReset',
    value: function updateBtnReset() {
      var dateFrom = this.dateFrom,
          dateTo = this.dateTo;

      var dateHasChanged = false;

      if (!this.initialDateFromString) {
        this.initialDateFromString = (0, _DateHelpers.getISODateString)(this.initialDateFrom);
        this.initialDateToString = (0, _DateHelpers.getISODateString)(this.initialDateTo);
      }

      if ((0, _DateHelpers.getISODateString)(dateFrom) !== this.initialDateFromString || (0, _DateHelpers.getISODateString)(dateTo) !== this.initialDateToString) {
        dateHasChanged = true;
      }

      this.$btnReset.prop('disabled', dateHasChanged === false);
    }
  }, {
    key: 'dispatchUpdate',
    value: function dispatchUpdate() {
      this.emit(EventListControls.UPDATE);
    }
  }, {
    key: 'getSearchDateRange',
    value: function getSearchDateRange() {
      var dateFrom = this.dateFrom,
          dateTo = this.dateTo;


      return {
        startDate: (0, _DateHelpers.startOfDay)(dateFrom),
        endDate: (0, _DateHelpers.endOfDay)(dateTo)
      };
    }
  }]);
  return EventListControls;
}(_events2.default);

EventListControls.UPDATE = 'tnEventListControls:update';

exports.default = EventListControls;

/***/ }),

/***/ "./V7/events/listing/listView/EventsListProductionsView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

var _EventsListControls = __webpack_require__("./V7/events/listing/listView/EventsListControls.js");

var _EventsListControls2 = _interopRequireDefault(_EventsListControls);

var _EventListingViewClasses = __webpack_require__("./V7/events/listing/EventListingViewClasses.js");

var _EventListingViewClasses2 = _interopRequireDefault(_EventListingViewClasses);

var _htmlShared = __webpack_require__("./V7/events/listing/htmlShared/index.js");

var _DateHelpers = __webpack_require__("./V7/events/listing/date/DateHelpers.js");

var _EventListingRangeFormatter = __webpack_require__("./V7/events/listing/date/EventListingRangeFormatter.js");

var _EventListingRangeFormatter2 = _interopRequireDefault(_EventListingRangeFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HTML = '\n  <div class="' + _EventListingViewClasses2.default.CONTROLS_CONTAINER + '"></div>\n  <div class="' + _EventListingViewClasses2.default.RESULTS_CONTAINER + '"></div>\n';

function makePerformanceListItemHtml(performance) {
  var id = performance.id,
      actionUrl = performance.actionUrl,
      displayDate = performance.displayDate,
      displayTime = performance.displayTime,
      performanceTitle = performance.performanceTitle,
      isOnSale = performance.isOnSale,
      performanceStatusMessage = performance.performanceStatusMessage,
      actionUrlText = performance.actionUrlText;


  return '\n    <li class="tn-prod-list-item__perf-list-item" data-tn-performance-no="' + id + '">\n      <a href="' + actionUrl + '" class="tn-prod-list-item__perf-anchor">\n        ' + (displayDate || displayTime ? '<span class="tn-prod-list-item__perf-property tn-prod-list-item__perf-property--datetime">\n            ' + (displayDate ? '<span class="tn-prod-list-item__perf-date">' + displayDate + '</span>' : '') + '\n            ' + (displayTime ? '<span class="tn-prod-list-item__perf-time">' + displayTime + '</span>' : '') + '\n            <span class="sr-only">,</span>\n          </span>' : '') + '\n        <span class="tn-prod-list-item__perf-property tn-prod-list-item__perf-property--title">\n          <span>' + performanceTitle + '</span><span class="sr-only">,</span>\n        </span>\n        <span class="tn-prod-list-item__perf-property tn-prod-list-item__perf-property--action">\n          ' + (isOnSale ? '\n              <span class="tn-prod-list-item__perf-action">' + actionUrlText + '</span>\n            ' : '') + '\n          ' + (isOnSale && performanceStatusMessage ? '<span class="sr-only">,</span>' : '') + '\n          ' + (performanceStatusMessage ? '\n              <span class="tn-prod-list-item__perf-status">' + performanceStatusMessage + '</span>\n            ' : '') + '\n        </span>\n        <span class="glyphicon glyphicon-chevron-right btn btn-primary" aria-hidden="true"></span>\n      </a>\n    </li>\n  ';
}

function makePerformanceListHtml(performances) {
  return '\n    <h5 class="sr-only">Items</h5>\n    <ul class="list-unstyled tn-prod-list-item__property tn-prod-list-item__property--perf-list">\n      ' + performances.map(makePerformanceListItemHtml).join('') + '\n    </ul>\n  ';
}

function makeProductionListItem(production) {
  var productionSeasonId = production.productionSeasonId,
      listingImageUrl = production.listingImageUrl,
      productionSeasonActionUrl = production.productionSeasonActionUrl,
      productionTitle = production.productionTitle,
      description = production.description,
      performances = production.performances,
      listingImageAlt = production.listingImageAlt,
      isPerformanceListVisible = production.isPerformanceListVisible;


  return '\n    <li data-tn-prod-season-no="' + productionSeasonId + '" class="tn-prod-list-item">\n      <h4 class="tn-prod-list-item__property tn-prod-list-item__property--heading">\n        <a href="' + productionSeasonActionUrl + '">' + productionTitle + '</a>\n      </h4>\n      ' + (description ? '\n        <div class="tn-prod-list-item__property tn-prod-list-item__property--description">\n          ' + description + '\n        </div>' : '') + '\n      ' + (isPerformanceListVisible && performances ? makePerformanceListHtml(performances) : '') + '\n\n      <div class="tn-prod-list-item__property tn-prod-list-item__property--img-container">\n        ' + (listingImageUrl ? '\n          <a href="' + productionSeasonActionUrl + '">\n            <img alt="' + listingImageAlt + '" src="' + listingImageUrl + '">\n          </a>' : '') + '\n      </div>\n    </li>\n  ';
}

var EventsListProductionsView = function () {
  function EventsListProductionsView(store, config) {
    var _this = this;

    (0, _classCallCheck3.default)(this, EventsListProductionsView);

    this.store = store;
    this.config = config;

    this.$el = (0, _jquery2.default)('#tn-events-list-view');
    this.$el.html(HTML);
    this.$el.prepend((0, _htmlShared.makeBusyIndicatorHtml)());

    this.$results = this.$el.find('.' + _EventListingViewClasses2.default.RESULTS_CONTAINER);
    this.$controls = this.$el.find('.' + _EventListingViewClasses2.default.CONTROLS_CONTAINER);

    this.controls = new _EventsListControls2.default(this.config);
    this.$controls.append(this.controls.$el);

    this.controls.on(_EventsListControls2.default.UPDATE, function () {
      _this.store.emit('date');
    });

    this.store.on('fetchStart', function () {
      _this.$el.addClass(_EventListingViewClasses2.default.LOADING_MODIFIER);
    });

    this.store.on('fetchEnd', function () {
      _this.$el.removeClass(_EventListingViewClasses2.default.LOADING_MODIFIER);
    });

    this.store.on('fetchFailed', function () {
      _this.$el.removeClass(_EventListingViewClasses2.default.LOADING_MODIFIER);
      _this.$results.html('');
    });

    this.$results.html((0, _htmlShared.makeResultsDateRangeHeading)(this.getResultsHeadingText()));
  }

  (0, _createClass3.default)(EventsListProductionsView, [{
    key: 'setData',
    value: function setData(data) {
      this.renderResults(data);
    }
  }, {
    key: 'getResultsHeadingText',
    value: function getResultsHeadingText() {
      if (this.config.hideListViewResultsHeading === true) {
        return '';
      }

      var _getRangeForSelectedD = this.getRangeForSelectedDate(),
          startDate = _getRangeForSelectedD.startDate,
          endDate = _getRangeForSelectedD.endDate;

      return _EventListingRangeFormatter2.default.range(startDate, endDate);
    }
  }, {
    key: 'renderResults',
    value: function renderResults(_ref) {
      var productions = _ref.productions;

      var _getRangeForSelectedD2 = this.getRangeForSelectedDate(),
          startDate = _getRangeForSelectedD2.startDate,
          endDate = _getRangeForSelectedD2.endDate;

      var filteredProductions = [];

      productions.forEach(function (production) {
        var filteredPerformances = production.performances.filter(function (perf) {
          return (0, _DateHelpers.isBetweenDates)(perf.iso8601Date, startDate, endDate);
        });

        if (filteredPerformances.length > 0) {
          filteredProductions.push((0, _assign2.default)({}, production, {
            performances: filteredPerformances
          }));
        }
      });

      if (filteredProductions.length) {
        var listItems = filteredProductions.map(makeProductionListItem).join('');

        this.$results.html('\n          ' + (0, _htmlShared.makeResultsDateRangeHeading)(this.getResultsHeadingText()) + '\n          <ul class="list-unstyled">' + listItems + '</ul>\n        ');
      } else {
        this.$results.html((0, _htmlShared.makeNoResultsHtml)(''));
      }
    }
  }, {
    key: 'getRangeForSelectedDate',
    value: function getRangeForSelectedDate() {
      return this.controls.getSearchDateRange();
    }
  }]);
  return EventsListProductionsView;
}();

exports.default = EventsListProductionsView;

/***/ }),

/***/ "./V7/events/listing/listView/EventsListView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _EventListingPrimaryView = __webpack_require__("./V7/events/listing/EventListingPrimaryView.js");

var _EventListingPrimaryView2 = _interopRequireDefault(_EventListingPrimaryView);

var _EventListingViewMode = __webpack_require__("./V7/events/listing/EventListingViewMode.js");

var _EventListingViewMode2 = _interopRequireDefault(_EventListingViewMode);

var _EventsListProductionsView = __webpack_require__("./V7/events/listing/listView/EventsListProductionsView.js");

var _EventsListProductionsView2 = _interopRequireDefault(_EventsListProductionsView);

var _DataStore = __webpack_require__("./V7/events/listing/api/DataStore.js");

var _DataStore2 = _interopRequireDefault(_DataStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventsListView = function (_EventListingPrimaryV) {
  (0, _inherits3.default)(EventsListView, _EventListingPrimaryV);

  function EventsListView(config, keywordFilter, viewToggle) {
    (0, _classCallCheck3.default)(this, EventsListView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EventsListView.__proto__ || (0, _getPrototypeOf2.default)(EventsListView)).call(this, config, keywordFilter, viewToggle));

    _this.store = new _DataStore2.default();
    _this.store.on('date', _this.fetchData.bind(_this));

    _this.resultsView = new _EventsListProductionsView2.default(_this.store, _this.config);
    return _this;
  }

  (0, _createClass3.default)(EventsListView, [{
    key: 'getCurrentView',
    value: function getCurrentView() {
      return this.resultsView;
    }
  }]);
  return EventsListView;
}(_EventListingPrimaryView2.default);

EventsListView.ViewMode = _EventListingViewMode2.default.LIST;

exports.default = EventsListView;

/***/ }),

/***/ "./V7/events/listing/listView/EventsListViewClasses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE = 'tn-events-list-view';
var INPUT_CONTAINER = BASE + '__datepicker-container';

var Class = {
  BASE: BASE,
  // INPUT_CONTAINER,
  INPUT_CONTAINER_FROM: INPUT_CONTAINER + '--from',
  INPUT_CONTAINER_TO: INPUT_CONTAINER + '--to',
  BTN_RESET: BASE + '__btn-reset-dates'
};

exports.default = Class;

/***/ }),

/***/ "./V7/events/listing/styles/event-listing.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./V7/events/listing/ui/TabNav.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = __webpack_require__("./node_modules/babel-runtime/core-js/map.js");

var _map2 = _interopRequireDefault(_map);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__("./node_modules/jquery/dist/jquery.js-exposed");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Attr = {
  MODE: 'data-tn-tab-mode',
  CONTENT_ID: 'data-tn-tab-content-id'
};

var Key = {
  RETURN: 13,
  SPACE_BAR: 32,
  LEFT: 37,
  RIGHT: 39,
  UP: 38,
  DOWN: 40
};

var TabNav = function () {
  function TabNav(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, TabNav);

    this.options = (0, _assign2.default)({}, {
      onChange: null,
      activeClass: 'active',
      mode: null
    }, options);

    this.init(el);
  }

  (0, _createClass3.default)(TabNav, [{
    key: 'init',
    value: function init(el) {
      var _this = this;

      this.modeMap = new _map2.default();
      this.dataArray = [];
      this.mode = this.options.mode;

      this.$nav = (0, _jquery2.default)(el);
      this.$nav.attr('role', 'tablist');

      this.$tabs = this.$nav.find('li');
      this.$tabs.toArray().forEach(function (tab, index) {
        var $tab = (0, _jquery2.default)(tab);
        var mode = $tab.attr(Attr.MODE);
        var tabId = $tab.attr('id');
        var contentId = $tab.attr(Attr.CONTENT_ID);
        var $target = (0, _jquery2.default)('#' + contentId).first();

        $tab.attr('aria-controls', contentId);
        $tab.attr('role', 'tab');

        $target.attr('aria-labelledby', tabId);
        $target.attr('role', 'tabpanel');

        var data = { $tab: $tab, $target: $target, index: index };

        _this.modeMap.set(mode, data); // To lookup by mode
        _this.dataArray.push(data); // To lookup by index
      });

      this.$tabs.on('keydown', function (event) {
        var key = event.which;

        var mod = null;

        switch (key) {
          case Key.RETURN:
          case Key.SPACE_BAR:
            (0, _jquery2.default)(event.target).click();
            return;
          case Key.LEFT:
          case Key.UP:
            mod = -1;
            break;
          case Key.RIGHT:
          case Key.DOWN:
            mod = 1;
            break;
          default:
            return;
        }

        if (mod === null) {
          return;
        }

        event.preventDefault();
        var $tab = (0, _jquery2.default)(event.target);
        var mode = $tab.attr(Attr.MODE);

        var index = _this.modeMap.get(mode).index; // this is super clunky - go off dom order?
        var numItems = _this.dataArray.length;
        var newIndex = index + mod;
        if (newIndex === -1) {
          newIndex = numItems - 1;
        } else {
          newIndex %= numItems;
        }

        var $newTab = _this.dataArray[newIndex].$tab;
        $newTab.focus();

        _this.modeMap.forEach(function (_ref) {
          var $tab = _ref.$tab;

          $tab.attr('tabindex', -1);
        });
      });

      this.$tabs.on('click', function (_ref2) {
        var currentTarget = _ref2.currentTarget;

        _this.setCurrentTab(currentTarget);
      });

      this.$tabs.on('blur', function (_ref3) {
        var relatedTarget = _ref3.relatedTarget;

        if (_this.$nav[0].contains(relatedTarget) === false) {
          _this.modeMap.forEach(function (_ref4, id) {
            var $tab = _ref4.$tab;

            var isCurrent = id === _this.mode;
            $tab.attr('tabindex', isCurrent ? 0 : -1);
          });
        }
      });

      // Activate either the specified mode:
      if (this.mode !== null) {
        this.setCurrentTab(this.modeMap.get(this.mode).$tab);
      } else {
        var $active = this.$tabs.filter('.' + this.options.activeClass);
        // The tab with an active class:
        if ($active.length) {
          this.setCurrentTab($active[0]);
        } else {
          // Or the first tab in the list:
          this.setCurrentTab(this.$tabs[0]);
        }
      }
    }
  }, {
    key: 'setCurrentTab',
    value: function setCurrentTab(tab) {
      var _this2 = this;

      var mode = (0, _jquery2.default)(tab).attr(Attr.MODE);

      if (tab === this.mode) {
        return;
      }

      this.mode = mode;

      var _options = this.options,
          activeClass = _options.activeClass,
          onChange = _options.onChange;


      this.modeMap.forEach(function (_ref5, id) {
        var $tab = _ref5.$tab,
            $target = _ref5.$target;

        var isCurrent = id === _this2.mode;

        $tab.toggleClass(activeClass, isCurrent);
        $tab.attr('aria-selected', isCurrent);
        $tab.attr('tabindex', isCurrent ? 0 : -1);

        $target.attr('aria-hidden', !isCurrent);
        $target.css('display', isCurrent ? '' : 'none');
      });

      if (onChange) {
        onChange(this.mode);
      }
    }
  }]);
  return TabNav;
}();

exports.default = TabNav;

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/get-iterator.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/is-iterable.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/json/stringify.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/map.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/map.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/get-own-property-descriptor.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/promise.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/promise.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/asyncToGenerator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("./node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/get.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/set-prototype-of.js");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("./node_modules/babel-runtime/core-js/object/create.js");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/slicedToArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("./node_modules/babel-runtime/core-js/is-iterable.js");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("./node_modules/babel-runtime/core-js/get-iterator.js");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/toConsumableArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("./node_modules/babel-runtime/core-js/symbol/iterator.js");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("./node_modules/babel-runtime/core-js/symbol.js");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "./node_modules/babel-runtime/regenerator/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/regenerator-runtime/runtime-module.js");


/***/ }),

/***/ "./node_modules/calendar-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var InvalidMonthError = __webpack_require__("./node_modules/calendar-js/src/errors/InvalidMonthError.js");
var InvalidMonthsError = __webpack_require__("./node_modules/calendar-js/src/errors/InvalidMonthsError.js");
var InvalidMonthsAbbrError = __webpack_require__("./node_modules/calendar-js/src/errors/InvalidMonthsAbbrError.js");

var InvalidWeekdayError = __webpack_require__("./node_modules/calendar-js/src/errors/InvalidWeekdayError.js");
var InvalidWeekdaysError = __webpack_require__("./node_modules/calendar-js/src/errors/InvalidWeekdaysError.js");
var InvalidWeekdaysAbbrError = __webpack_require__("./node_modules/calendar-js/src/errors/InvalidWeekdaysAbbrError.js");

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function generateAbbr(arr, len) {
  return arr.map(function (item) {
    return item.slice(0, len || 3);
  });
}

function createArray(length) {
  var a = [];

  for (var i = 0; i < length; i++) {
    a.push(1);
  }

  return a;
}

function calendar(config) {
  var abbrLengthWeek = config && !isNaN(config.abbrWeek) && config.abbrWeek > 0 ? config.abbrWeek : 3;
  var abbrLengthMonth = config && !isNaN(config.abbrMonth) && config.abbrMonth > 0 ? config.abbrMonth : 3;

  var _months = MONTHS;
  var _monthsAbbr = generateAbbr(MONTHS, abbrLengthMonth);
  var _weekdays = WEEKDAYS;
  var _weekdaysAbbr = generateAbbr(WEEKDAYS, abbrLengthWeek);

  if (config && config.months) {
    if (!Array.isArray(config.months) || config.months.length !== 12) {
      throw new InvalidMonthsError('Months array must have 12 values');
    }

    _months = config.months;
    _monthsAbbr = generateAbbr(config.months, abbrLengthMonth);
  }

  if (config && config.monthsAbbr) {
    if (!Array.isArray(config.monthsAbbr) || config.monthsAbbr.length !== 12) {
      throw new InvalidMonthsAbbrError('Months array must have 12 values');
    }

    _monthsAbbr = config.monthsAbbr;
  }

  if (config && config.weekdays) {
    if (!Array.isArray(config.weekdays) || config.weekdays.length !== 7) {
      throw new InvalidWeekdaysError('Weekdays array must have 7 values');
    }

    _weekdays = config.weekdays;
    _weekdaysAbbr = generateAbbr(config.weekdays, abbrLengthWeek);
  }

  if (config && config.weekdaysAbbr) {
    if (!Array.isArray(config.weekdaysAbbr) || config.weekdaysAbbr.length !== 7) {
      throw new InvalidWeekdaysAbbrError('Weekdays array must have 7 values');
    }

    _weekdaysAbbr = config.weekdaysAbbr;
  }

  return {
    months: function months() {
      return _months;
    },

    monthsAbbr: function monthsAbbr() {
      return _monthsAbbr;
    },

    years: function years(from, to) {
      if (from > to) {
        throw new RangeError('The first year argument cannot be greater than the second');
      }

      var years = [from.toString()];
      var totalYears = to - from + 1;

      while (years.length < totalYears) {
        var year = parseInt(years[years.length - 1], 10) + 1;

        years.push(year.toString());
      }

      return years;
    },

    yearsAbbr: function yearsAbbr(from, to) {
      var years = this.years(from, to).map(function (year) {
        return year.toString().substring(2);
      });

      return years.length > 1 ? years : years[0];
    },

    weekdays: function weekdays() {
      return _weekdays;
    },

    weekdaysAbbr: function weekdaysAbbr() {
      return _weekdaysAbbr;
    },

    generateCalendar: function generateCalendar(year, month, numberOfDays, firstWeekday, lastWeekday, dayTransformer, cbData) {
      var calendar = [];
      var totalWeeks = Math.ceil((numberOfDays + firstWeekday) / 7);
      var totalDaysOnWeek = 7;
      var lastWeek = totalWeeks - 1;
      var execCb = typeof dayTransformer === 'function';

      var lastDay = firstWeekday * -1;
      var weeks = [];

      createArray(totalWeeks).forEach(function (_, week) {
        createArray(totalDaysOnWeek).forEach(function (_, day) {
          lastDay++;

          var date = new Date(year, month, lastDay);

          var data = {
            date: date,
            day: date.getDate(),
            isInPrimaryMonth: date.getMonth() === month,
            isInLastWeekOfPrimaryMonth: week === lastWeek,
            index: {
              day: day,
              week: week
            }
          };

          if (execCb) {
            var result = dayTransformer(data, cbData);

            if (result !== undefined) {
              data = result;
            }
          }

          weeks.push(data);
        });

        calendar.push(weeks);

        weeks = [];
      });

      return calendar;
    },

    of: function of(year, month, transformer) {
      var data = this.detailed(year, month, function (data) {
        return data.isInPrimaryMonth ? data.day : 0;
      });

      if (typeof transformer === 'function') {
        return transformer(data);
      }

      return data;
    },

    detailed: function detailed(year, month, dayTransformer) {
      if (month < 0 || month > 11) {
        throw new InvalidMonthError('Month should be beetwen 0 and 11');
      }

      if (typeof year !== 'number' || typeof month !== 'number') {
        throw new Error('Arguments should be numbers');
      }

      var numberOfDays = new Date(year, month + 1, 0).getDate();
      var firstWeekday = new Date(year, month, 1).getDay();
      var lastWeekday = new Date(year, month, numberOfDays).getDay();

      var data = {
        year: year.toString(),
        yearAbbr: this.yearsAbbr(year),
        month: this.months()[month],
        monthAbbr: this.monthsAbbr()[month],
        weekdays: this.weekdays(),
        weekdaysAbbr: this.weekdaysAbbr(),
        days: numberOfDays,
        firstWeekday: firstWeekday,
        lastWeekday: lastWeekday
      };

      var calendar = this.generateCalendar(year, month, numberOfDays, firstWeekday, lastWeekday, dayTransformer, data);

      data.calendar = calendar;

      return data;
    },

    validate: function validate(year, month, day) {
      var date = new Date(year, month, day);

      return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
    }
  };
}

module.exports = calendar;

/***/ }),

/***/ "./node_modules/calendar-js/src/errors/InvalidMonthError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function InvalidMonthError(message) {
  this.message = message;
  this.name = 'InvalidMonthError';
};

/***/ }),

/***/ "./node_modules/calendar-js/src/errors/InvalidMonthsAbbrError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function InvalidMonthsAbbrError(message) {
  this.message = message;
  this.name = 'InvalidMonthsAbbrError';
};

/***/ }),

/***/ "./node_modules/calendar-js/src/errors/InvalidMonthsError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function InvalidMonthsError(message) {
  this.message = message;
  this.name = 'InvalidMonthsError';
};

/***/ }),

/***/ "./node_modules/calendar-js/src/errors/InvalidWeekdayError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function InvalidMonthError(message) {
  this.message = message;
  this.name = 'InvalidWeekdayError';
};

/***/ }),

/***/ "./node_modules/calendar-js/src/errors/InvalidWeekdaysAbbrError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function InvalidMonthsAbbrError(message) {
  this.message = message;
  this.name = 'InvalidWeekdaysAbbrError';
};

/***/ }),

/***/ "./node_modules/calendar-js/src/errors/InvalidWeekdaysError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function InvalidMonthsError(message) {
  this.message = message;
  this.name = 'InvalidWeekdaysError';
};

/***/ }),

/***/ "./node_modules/core-js/library/fn/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.array.from.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Array.from;


/***/ }),

/***/ "./node_modules/core-js/library/fn/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator.js");


/***/ }),

/***/ "./node_modules/core-js/library/fn/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/core.is-iterable.js");


/***/ }),

/***/ "./node_modules/core-js/library/fn/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/map.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.map.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.map.to-json.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.map.of.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.map.from.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Map;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.create.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.define-property.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js/library/fn/promise.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.promise.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.promise.finally.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.promise.try.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Promise;


/***/ }),

/***/ "./node_modules/core-js/library/fn/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.symbol.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/es7.symbol.observable.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Symbol;


/***/ }),

/***/ "./node_modules/core-js/library/fn/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/web.dom.iterable.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-from-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var asc = __webpack_require__("./node_modules/core-js/library/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var isArray = __webpack_require__("./node_modules/core-js/library/modules/_is-array.js");
var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
var redefineAll = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
var $iterDefine = __webpack_require__("./node_modules/core-js/library/modules/_iter-define.js");
var step = __webpack_require__("./node_modules/core-js/library/modules/_iter-step.js");
var setSpecies = __webpack_require__("./node_modules/core-js/library/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var fastKey = __webpack_require__("./node_modules/core-js/library/modules/_meta.js").fastKey;
var validate = __webpack_require__("./node_modules/core-js/library/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_collection-to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var from = __webpack_require__("./node_modules/core-js/library/modules/_array-from-iterable.js");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var meta = __webpack_require__("./node_modules/core-js/library/modules/_meta.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var redefineAll = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var each = __webpack_require__("./node_modules/core-js/library/modules/_array-methods.js")(0);
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var call = __webpack_require__("./node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/library/modules/_is-array-iter.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var getIterFn = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("./node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("./node_modules/core-js/library/modules/_uid.js")('meta');
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var setDesc = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var macrotask = __webpack_require__("./node_modules/core-js/library/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("./node_modules/core-js/library/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("./node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("./node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var gOPN = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-collection-from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-collection-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("./node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
var SPECIES = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var invoke = __webpack_require__("./node_modules/core-js/library/modules/_invoke.js");
var html = __webpack_require__("./node_modules/core-js/library/modules/_html.js");
var cel = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("./node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_user-agent.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "./node_modules/core-js/library/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
var defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("./node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "./node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/core.get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var get = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/core.is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var call = __webpack_require__("./node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/library/modules/_is-array-iter.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var createProperty = __webpack_require__("./node_modules/core-js/library/modules/_create-property.js");
var getIterFn = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("./node_modules/core-js/library/modules/_add-to-unscopables.js");
var step = __webpack_require__("./node_modules/core-js/library/modules/_iter-step.js");
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("./node_modules/core-js/library/modules/_collection-strong.js");
var validate = __webpack_require__("./node_modules/core-js/library/modules/_validate-collection.js");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_collection.js")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("./node_modules/core-js/library/modules/_object-create.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js").f;

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("./node_modules/core-js/library/modules/_set-proto.js").set });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
var anInstance = __webpack_require__("./node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("./node_modules/core-js/library/modules/_for-of.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_species-constructor.js");
var task = __webpack_require__("./node_modules/core-js/library/modules/_task.js").set;
var microtask = __webpack_require__("./node_modules/core-js/library/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/library/modules/_perform.js");
var userAgent = __webpack_require__("./node_modules/core-js/library/modules/_user-agent.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/library/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("./node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("./node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("./node_modules/core-js/library/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("./node_modules/core-js/library/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("./node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
var META = __webpack_require__("./node_modules/core-js/library/modules/_meta.js").KEY;
var $fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
var wks = __webpack_require__("./node_modules/core-js/library/modules/_wks.js");
var wksExt = __webpack_require__("./node_modules/core-js/library/modules/_wks-ext.js");
var wksDefine = __webpack_require__("./node_modules/core-js/library/modules/_wks-define.js");
var enumKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-keys.js");
var isArray = __webpack_require__("./node_modules/core-js/library/modules/_is-array.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
var _create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
var gOPNExt = __webpack_require__("./node_modules/core-js/library/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("./node_modules/core-js/library/modules/_object-gopd.js");
var $DP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("./node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
  __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("./node_modules/core-js/library/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("./node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.map.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("./node_modules/core-js/library/modules/_set-collection-from.js")('Map');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.map.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("./node_modules/core-js/library/modules/_set-collection-of.js")('Map');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.map.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("./node_modules/core-js/library/modules/_collection-to-json.js")('Map') });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.promise.finally.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var speciesConstructor = __webpack_require__("./node_modules/core-js/library/modules/_species-constructor.js");
var promiseResolve = __webpack_require__("./node_modules/core-js/library/modules/_promise-resolve.js");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.promise.try.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var newPromiseCapability = __webpack_require__("./node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("./node_modules/core-js/library/modules/_perform.js");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ }),

/***/ "./node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.array.iterator.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var TO_STRING_TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "./node_modules/events/events.js":
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime-module.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("./node_modules/regenerator-runtime/runtime.js");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./V7/events/listing/EventListing.js");
module.exports = __webpack_require__("./V7/events/listing/styles/event-listing.scss");


/***/ })

},[3]);


// WEBPACK FOOTER //
// tnew-event-listing.a725378572dc39134533.js